import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getFrontImage, getLocalizedAttrValue, getAttrValue, isString, withPlusSign, getLocalizedValue, isDefined } from '@grandvisionhq/utils';
import * as React from 'react';
import { Button, MediaQuery, Price, DiscountBar, IconButton, LineItemDeleteButton, QuantitySelector, Types, LineItemGlassesPrescription, LineItemBundleRow, Alert, Tooltip, Loader, CartCounter, Modal, LineItem, LineItemMedia, LineItemContent, LineItemAside, StickyCallToAction, Util, toast } from '@grandvisionhq/common';
import { actions as actions$1, useIntl, useDispatch, withIntl, statusUninit, statusLoading, statusFailed, connect, withFeatureToggles, statusSuccess, uninitState, successState, warningState, failedState, loadingState, ApiConfigSelectors, ReducersRegistry, SagaRegistry } from '@grandvisionhq/state';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import get from 'lodash/get';
import { DiscountCodeForm } from '@grandvisionhq/forms';
import { Helpers, StockIndicator } from '@grandvisionhq/inventory';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import classnames from 'classnames';
import { createSelector } from 'reselect';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { put, call, select, cancel, all, takeLatest, takeLeading } from 'redux-saga/effects';
import { addToCartSdAction, updateQuantitySdAction, removeLineItemsSdAction } from '@grandvisionhq/analytics';
import { Carts } from '@grandvisionhq/api-client';

/**
 * Calculates the total amount of items in the cart,
 * taking into account that 1 line item can have a quantity higher than 1
 * Does not add additional cart costs to the amount
 */
var calcCartItemsCount = function (lineItems, prescriptionGlassesLineItems) {
    if (prescriptionGlassesLineItems === void 0) { prescriptionGlassesLineItems = []; }
    var lineItemCount = lineItems
        .filter(function (lineItem) {
        return !CommerceToolsApi.isAdditionalCartCosts((lineItem.productType &&
            lineItem.productType.obj &&
            lineItem.productType.obj.name.toString()) ||
            '');
    })
        .map(function (lineItems) { return lineItems.quantity || 0; })
        .reduce(function (a, b) { return a + b; }, 0);
    var prescriptionGlassesLineItemCount = prescriptionGlassesLineItems
        .map(function (lineItem) { return lineItem.quantity || 0; })
        .reduce(function (a, b) { return a + b; }, 0);
    return lineItemCount + prescriptionGlassesLineItemCount;
};

var getItemImageUrl = function (staticsUrl, item, isBynderImagesEnabled) {
    var _a, _b, _c, _d;
    if (isBynderImagesEnabled) {
        var imageUrl = getFrontImage((_a = item.variant.media) === null || _a === void 0 ? void 0 : _a.images).url;
        return imageUrl + "?w=275&bg=FFFFFF&fm=jpeg&auto=format";
    }
    if ((_d = (_c = (_b = item === null || item === void 0 ? void 0 : item.variant) === null || _b === void 0 ? void 0 : _b.images) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.url) {
        return "" + staticsUrl + (item.variant.images && item.variant.images[0].url) + "?w=275&bg=FFFFFF&fm=jpeg&auto=format";
    }
    return '';
};

var getDefaultShippingMethod = function (shippingMethods) {
    var defaultMethod = shippingMethods.find(function (method) { return method.isDefault; });
    if (defaultMethod) {
        return defaultMethod;
    }
    console.warn('No default shipping method configured in Commercetools');
    var firstMethod = shippingMethods[0];
    if (firstMethod) {
        return firstMethod;
    }
    console.error('There are no shipping method configured in Commercetools');
    return undefined;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

var setDefaultQuantity = function (item) {
    var _a;
    return (__assign(__assign({}, item), { quantity: (_a = item.quantity) !== null && _a !== void 0 ? _a : 1 }));
};
function parseAddToCartPayload(payload, isUpdate) {
    var e_1, _a;
    if (isUpdate === void 0) { isUpdate = false; }
    var _b = payload.lineItems, lineItems = _b === void 0 ? [] : _b, prescriptionGlassesBundleLineItems = payload.prescriptionGlassesBundleLineItems, currency = payload.currency, country = payload.country, locale = payload.locale;
    var enrichedLineItems = [];
    try {
        for (var lineItems_1 = __values(lineItems), lineItems_1_1 = lineItems_1.next(); !lineItems_1_1.done; lineItems_1_1 = lineItems_1.next()) {
            var lineItem = lineItems_1_1.value;
            var sku = lineItem.sku, _c = lineItem.quantity, quantity = _c === void 0 ? 1 : _c, customAttributes = lineItem.customAttributes, custom = lineItem.custom;
            var enrichedLineItem = {
                sku: sku,
                quantity: quantity,
            };
            // This basically means contact-lens or contact-lens-bundles
            var hasCustomData = !!custom || !!customAttributes;
            if (hasCustomData) {
                var _d = custom || customAttributes || {}, _e = _d.type, type = _e === void 0 ? 'contact-lens' : _e, fields = __rest(_d, ["type"]);
                var customObject = isUpdate
                    ? {
                        type: {
                            key: type,
                        },
                        fields: fields,
                    }
                    : __assign({ type: type }, fields);
                enrichedLineItem = __assign(__assign({}, enrichedLineItem), { custom: customObject });
            }
            enrichedLineItems.push(enrichedLineItem);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (lineItems_1_1 && !lineItems_1_1.done && (_a = lineItems_1.return)) _a.call(lineItems_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var enrichedPrescriptionGlassesBundleLineItems = prescriptionGlassesBundleLineItems === null || prescriptionGlassesBundleLineItems === void 0 ? void 0 : prescriptionGlassesBundleLineItems.map(function (bundle) { return (__assign(__assign({}, bundle), { bundleMainLineItem: setDefaultQuantity(bundle.bundleMainLineItem), bundleChildLineItems: bundle.bundleChildLineItems.map(setDefaultQuantity) })); });
    return {
        lineItems: enrichedLineItems,
        prescriptionGlassesLineItems: enrichedPrescriptionGlassesBundleLineItems,
        currency: currency,
        country: country,
        locale: locale,
        shippingAddress: {
            country: country,
        },
        custom: {
            type: {
                key: 'order-grandvision',
                typeId: 'type',
            },
        },
    };
}

/**
 * This method retrieves the discount with the given name
 * from an array of discountCodes.
 */
var findAppliedDiscount = function (discountCodeName, discountCodes) {
    return discountCodes.find(function (code) { return code.discountCode.obj && code.discountCode.obj.code === discountCodeName; });
};

/**
 * This method checks for changes between discountcode states
 * This is called in sagas which mutate the cart from the cartpage
 */
function getChangedDiscountCodes(prevCodes, newCodes) {
    // Loop over the new codes and find the matching id from the old codes
    // if we find a matching code and the state has been mutated, return the code
    return newCodes.filter(function (item) {
        var prevItem = prevCodes.find(function (prevItem) { return item.discountCode.id === prevItem.discountCode.id; });
        return prevItem && prevItem.state !== item.state;
    });
}

var hasPrescriptionGlassesInCart = function (cart) {
    var _a;
    return Boolean(((_a = cart === null || cart === void 0 ? void 0 : cart.prescriptionGlassesLineItems) === null || _a === void 0 ? void 0 : _a.length) && cart.prescriptionGlassesLineItems.length > 0);
};

var discountCodeValidationMap = {
    NotValid: 'validations.discountcode.notvalid',
    NotActive: 'validations.discountcode.notactive',
    MatchesCart: 'validations.discountcode.matchescart',
    DoesNotMatchCart: 'validations.discountcode.doesnotmatchcart',
    MaxApplicationReached: 'validations.discountcode.maxapplicationreached',
    ApplicationStoppedByPreviousDiscount: 'validations.discountcode.applicationstoppedbypreviousdiscount',
};

var CartService = function () {
    var localStorage = window.localStorage;
    var CART_TOKEN = 'stored_cart';
    var emptyCart = function () { return ({
        cartVersion: 0,
        cartCount: 0,
    }); };
    var setCartId = function (cartId) {
        return setCartToStorage(__assign(__assign({}, getCartFromStorage()), { cartId: cartId }));
    };
    var getCartId = function () {
        var cart = getCartFromStorage();
        if (!cart) {
            return undefined;
        }
        return cart.cartId;
    };
    var setCartVersion = function (cartVersion) {
        return setCartToStorage(__assign(__assign({}, getCartFromStorage()), { cartVersion: cartVersion }));
    };
    var getCartCount = function () {
        var cart = getCartFromStorage();
        if (!cart) {
            return 0;
        }
        return cart.cartCount;
    };
    var setCartCount = function (cartCount) {
        return setCartToStorage(__assign(__assign({}, getCartFromStorage()), { cartCount: cartCount }));
    };
    var setCartToStorage = function (cart) {
        var newCart = cart || emptyCart();
        localStorage.setItem(CART_TOKEN, JSON.stringify(newCart));
    };
    var getCartVersion = function () {
        var cart = getCartFromStorage();
        if (!cart) {
            return 0;
        }
        return cart.cartVersion;
    };
    var getCartFromStorage = function () {
        var fromStorage = localStorage.getItem(CART_TOKEN);
        if (!fromStorage) {
            return emptyCart();
        }
        try {
            return JSON.parse(fromStorage);
        }
        catch (err) {
            console.error("Error while parsing cart from localStorage; tried to parse \"" + fromStorage, err);
        }
        return emptyCart();
    };
    var removeCartFromStorage = function () {
        if (!localStorage.getItem(CART_TOKEN)) {
            return;
        }
        localStorage.removeItem(CART_TOKEN);
    };
    return {
        getCartId: getCartId,
        setCartId: setCartId,
        getCartCount: getCartCount,
        setCartCount: setCartCount,
        getCartVersion: getCartVersion,
        setCartVersion: setCartVersion,
        getCartFromStorage: getCartFromStorage,
        setCartToStorage: setCartToStorage,
        removeCartFromStorage: removeCartFromStorage,
    };
};
var hasLocalCart = function () {
    if (typeof window === 'undefined' || !window.localStorage) {
        return false;
    }
    var storedCart = JSON.parse(window.localStorage.getItem('stored_cart') || '{}');
    return storedCart && !!storedCart.cartId && !!storedCart.cartVersion;
};

var getProductTypeNames = function (cart) {
    var _a, _b;
    return (_b = (cart &&
        ((_a = cart.lineItems) === null || _a === void 0 ? void 0 : _a.map(function (lineItem) { var _a, _b, _c; return (_c = (_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.productType) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : 'Unknown'; })))) !== null && _b !== void 0 ? _b : [];
};

var hasRegularLineItems = function (cart) {
    return cart.lineItems.length > 0;
};
var hasPrescriptionGlassesLineItems = function (cart) { var _a, _b; return ((_b = (_a = cart.prescriptionGlassesLineItems) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0; };
var isEmptyCart = function (cart) {
    var _a, _b, _c, _d;
    var count = cart.lineItems.length;
    var customCount = (_b = (_a = cart.customLineItems) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    var pgCount = (_d = (_c = cart.prescriptionGlassesLineItems) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
    return count + pgCount + customCount < 1;
};
var hasOnlyAdditionalCosts = function (cart) {
    var cartProductTypes = getProductTypeNames(cart);
    return (!!cartProductTypes.length && cartProductTypes.every(function (type) { return type === 'Additional-cart-costs'; }));
};

function getBundleItemImage(bundleItem, bundleSolution) {
    var _a, _b, _c, _d, _e, _f;
    var result = { itemImageUrl: '', solutionImageUrl: '' };
    if (bundleItem !== undefined) {
        var itemImages = (_c = (_b = (_a = bundleItem.obj) === null || _a === void 0 ? void 0 : _a.masterData.current.masterVariant.media) === null || _b === void 0 ? void 0 : _b.images) !== null && _c !== void 0 ? _c : [];
        var itemImageUrl = getFrontImage(itemImages).url;
        result.itemImageUrl = itemImageUrl + "?w=275&bg=FFFFFF&fm=jpeg&auto=format";
    }
    if (bundleSolution !== undefined) {
        var solutionImages = (_f = (_e = (_d = bundleSolution.obj) === null || _d === void 0 ? void 0 : _d.masterData.current.masterVariant.media) === null || _e === void 0 ? void 0 : _e.images) !== null && _f !== void 0 ? _f : [];
        var solutionImageUrl = getFrontImage(solutionImages).url;
        result.solutionImageUrl = solutionImageUrl + "?w=275&bg=FFFFFF&fm=jpeg&auto=format";
    }
    return result;
}

var hasContactLensesSubscriptionInCart = function (cart) {
    var _a;
    return Boolean((_a = cart === null || cart === void 0 ? void 0 : cart.customLineItems) === null || _a === void 0 ? void 0 : _a.find(function (item) { var _a; return ((_a = item.custom) === null || _a === void 0 ? void 0 : _a.fields.bundleLineItemsType) === 'CONTACT_LENSES_SUBSCRIPTION'; }));
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  calcCartItemsCount: calcCartItemsCount,
  getItemImageUrl: getItemImageUrl,
  getDefaultShippingMethod: getDefaultShippingMethod,
  parseAddToCartPayload: parseAddToCartPayload,
  findAppliedDiscount: findAppliedDiscount,
  getChangedDiscountCodes: getChangedDiscountCodes,
  hasPrescriptionGlassesInCart: hasPrescriptionGlassesInCart,
  discountCodeValidationMap: discountCodeValidationMap,
  CartService: CartService,
  hasLocalCart: hasLocalCart,
  hasRegularLineItems: hasRegularLineItems,
  hasPrescriptionGlassesLineItems: hasPrescriptionGlassesLineItems,
  isEmptyCart: isEmptyCart,
  hasOnlyAdditionalCosts: hasOnlyAdditionalCosts,
  getProductTypeNames: getProductTypeNames,
  getBundleItemImage: getBundleItemImage,
  hasContactLensesSubscriptionInCart: hasContactLensesSubscriptionInCart
});

var CART_LOAD = 'cart/CART_LOAD';
var CART_SUCCESS = 'cart/CART_SUCCESS';
var CART_WARNING = 'cart/CART_WARNING';
var CART_FAILED = 'cart/CART_FAILED';
var CART_VALIDATION_FAILED = 'cart/CART_VALIDATION_FAILED';
var ADD_TO_CART = 'cart/ADD_TO_CART';
var ADD_TO_CART_FAILED = 'cart/ADD_TO_CART_FAILED';
var ADD_TO_CART_SUCCESS = 'cart/ADD_TO_CART_SUCCESS';
var CREATE_CART = 'cart/CREATE_CART';
var UPDATE_LOCAL_CART = 'cart/UPDATE_LOCAL_CART';
var UPDATE_CART = 'cart/UPDATE_CART';
var UPDATE_SHIPPING_METHOD = 'cart/UPDATE_SHIPPING_METHOD';
var CHANGE_QUANTITY = 'cart/UPDATE_QUANTITY';
var ADD_DISCOUNT_CODE = 'cart/ADD_DISCOUNT_CODE';
var ADD_DISCOUNT_CODE_SUCCESS = 'cart/ADD_DISCOUNT_CODE_SUCCESS';
var REMOVE_DISCOUNT_CODE = 'cart/REMOVE_DISCOUNT_CODE';
var ADD_LINE_ITEMS = 'cart/ADD_LINE_ITEMS';
var REPLICATE_CART = 'cart/REPLICATE_CART';
var REFRESH_CART = 'cart/REFRESH_CART';
var REFRESH_CART_FAILED = 'cart/REFRESH_CART_FAILED';
var REFRESH_CART_SUCCESS = 'cart/REFRESH_CART_SUCCESS';
var addToCartSequence = (function (seed) {
    var current = seed;
    return function () {
        current++;
        return current;
    };
})(0);
var addToCart$1 = function (payload) { return ({
    type: ADD_TO_CART,
    sequenceId: addToCartSequence(),
    payload: payload,
}); };
var addToCartFailed = function (error, sequenceId) { return ({
    type: ADD_TO_CART_FAILED,
    sequenceId: sequenceId,
    error: error,
}); };
var addToCartSuccess = function (sequenceId) { return ({
    type: ADD_TO_CART_SUCCESS,
    sequenceId: sequenceId,
}); };
var loadCart = function (payload) { return ({
    type: CART_LOAD,
    payload: payload,
}); };
var cartSuccess = function (payload) { return ({
    type: CART_SUCCESS,
    payload: payload,
}); };
var cartFailed = function (payload) { return ({
    type: CART_FAILED,
    payload: payload,
}); };
var cartValidationFailed = function (payload) { return ({
    type: CART_VALIDATION_FAILED,
    payload: payload,
}); };
var cartWarning = function (payload) { return ({
    type: CART_WARNING,
    payload: payload,
}); };
var createCart$1 = function (payload) { return ({
    type: CREATE_CART,
    payload: payload,
}); };
var updateLocalCart = function (payload) { return ({
    type: UPDATE_LOCAL_CART,
    payload: payload,
}); };
var updateCart$1 = function (payload) { return ({
    type: UPDATE_CART,
    payload: payload,
}); };
var updateShippingMethod = function (payload) { return ({
    type: UPDATE_SHIPPING_METHOD,
    payload: payload,
}); };
var changeQuantity = function (payload) { return ({
    type: CHANGE_QUANTITY,
    payload: payload,
}); };
var addDiscountCode$1 = function (payload) { return ({
    type: ADD_DISCOUNT_CODE,
    payload: payload,
}); };
var removeDiscountCode$1 = function (payload) { return ({
    type: REMOVE_DISCOUNT_CODE,
    payload: payload,
}); };
var addDiscountCodeSuccess = function (payload) { return ({
    type: ADD_DISCOUNT_CODE_SUCCESS,
    payload: payload,
}); };
var addLineItems$1 = function (payload) { return ({
    type: ADD_LINE_ITEMS,
    payload: payload,
}); };
var removeLineItems = actions$1.action('cart/REMOVE_LINE_ITEMS', actions$1.payload());
var removeCustomLineItems = actions$1.action('cart/REMOVE_CUSTOM_LINE_ITEMS', actions$1.payload());
var replicateCart$1 = function (payload) { return ({
    type: REPLICATE_CART,
    payload: payload,
}); };
var refreshCart$1 = function () { return ({
    type: REFRESH_CART,
}); };
var refreshCartFailed = function (error) { return ({
    type: REFRESH_CART_FAILED,
    error: error,
}); };
var refreshCartSuccess = function (payload) { return ({
    type: REFRESH_CART_SUCCESS,
    payload: payload,
}); };

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CART_LOAD: CART_LOAD,
  CART_SUCCESS: CART_SUCCESS,
  CART_WARNING: CART_WARNING,
  CART_FAILED: CART_FAILED,
  CART_VALIDATION_FAILED: CART_VALIDATION_FAILED,
  ADD_TO_CART: ADD_TO_CART,
  ADD_TO_CART_FAILED: ADD_TO_CART_FAILED,
  ADD_TO_CART_SUCCESS: ADD_TO_CART_SUCCESS,
  CREATE_CART: CREATE_CART,
  UPDATE_LOCAL_CART: UPDATE_LOCAL_CART,
  UPDATE_CART: UPDATE_CART,
  UPDATE_SHIPPING_METHOD: UPDATE_SHIPPING_METHOD,
  CHANGE_QUANTITY: CHANGE_QUANTITY,
  ADD_DISCOUNT_CODE: ADD_DISCOUNT_CODE,
  ADD_DISCOUNT_CODE_SUCCESS: ADD_DISCOUNT_CODE_SUCCESS,
  REMOVE_DISCOUNT_CODE: REMOVE_DISCOUNT_CODE,
  ADD_LINE_ITEMS: ADD_LINE_ITEMS,
  REPLICATE_CART: REPLICATE_CART,
  REFRESH_CART: REFRESH_CART,
  REFRESH_CART_FAILED: REFRESH_CART_FAILED,
  REFRESH_CART_SUCCESS: REFRESH_CART_SUCCESS,
  addToCartSequence: addToCartSequence,
  addToCart: addToCart$1,
  addToCartFailed: addToCartFailed,
  addToCartSuccess: addToCartSuccess,
  loadCart: loadCart,
  cartSuccess: cartSuccess,
  cartFailed: cartFailed,
  cartValidationFailed: cartValidationFailed,
  cartWarning: cartWarning,
  createCart: createCart$1,
  updateLocalCart: updateLocalCart,
  updateCart: updateCart$1,
  updateShippingMethod: updateShippingMethod,
  changeQuantity: changeQuantity,
  addDiscountCode: addDiscountCode$1,
  removeDiscountCode: removeDiscountCode$1,
  addDiscountCodeSuccess: addDiscountCodeSuccess,
  addLineItems: addLineItems$1,
  removeLineItems: removeLineItems,
  removeCustomLineItems: removeCustomLineItems,
  replicateCart: replicateCart$1,
  refreshCart: refreshCart$1,
  refreshCartFailed: refreshCartFailed,
  refreshCartSuccess: refreshCartSuccess
});

var AddToCart = function (props) { return (React.createElement(Button, __assign({ size: "custom", "data-t": "add-to-cart", className: "add-to-cart" }, props))); };

var AddToCartContainer = function (_a) {
    var caption = _a.caption, lineItems = _a.lineItems, formatProductUrl = _a.formatProductUrl, variant = _a.variant, size = _a.size, disabled = _a.disabled, onClick = _a.onClick;
    var _b = useIntl(), currency = _b.currency, country = _b.country, locale = _b.locale;
    var dispatch = useDispatch();
    var isPhone = MediaQuery.useIsPhone();
    var defaultButtonSize = isPhone ? 'small' : 'medium';
    var handleClick = React.useCallback(function () {
        onClick && onClick();
        dispatch(addToCart$1({
            lineItems: lineItems,
            currency: currency,
            country: country,
            locale: locale,
            formatProductUrl: formatProductUrl,
        }));
    }, [currency, country, locale, dispatch, lineItems, formatProductUrl, onClick]);
    if (!lineItems.length) {
        return null;
    }
    return (React.createElement(AddToCart, { caption: caption, variant: variant, size: size || defaultButtonSize, disabled: disabled, onClick: handleClick }));
};

var AddToCartNotification = function (_a) {
    var price = _a.price, stickerText = _a.stickerText, ean = _a.ean, productName = _a.productName, imgUrl = _a.imgUrl, onClose = _a.onClose, cartRoute = _a.cartRoute, _b = _a.color, color = _b === void 0 ? 'primary' : _b;
    var _c = useIntl(), getLabel = _c.getLabel, currency = _c.currency;
    var discountedPrice;
    if (price.discountedPrice) {
        discountedPrice = price.discountedPrice;
    }
    var hasDiscount = discountedPrice && price.originalPrice !== discountedPrice;
    return (React.createElement("div", { className: "add-to-cart-notification" },
        React.createElement("div", { className: "add-to-cart-notification__title-bar" },
            React.createElement(Heading, { variant: "smallest", className: "add-to-cart-notification__title" }, getLabel('cart.notification.title')),
            React.createElement("button", { className: "add-to-cart-notification__close-button", type: "button", onClick: onClose, "data-t": "close" },
                React.createElement(Icon, { name: "close" }))),
        React.createElement("div", { className: "add-to-cart-notification__product" },
            React.createElement("div", { className: "add-to-cart-notification__product-image" },
                React.createElement("img", { src: imgUrl + '?w=200&fm=jpeg&auto=format', alt: productName })),
            React.createElement("div", { className: "add-to-cart-notification__product-specification" },
                React.createElement("span", { className: "add-to-cart-notification__product-title" }, productName),
                React.createElement("span", { className: "add-to-cart-notification__product-ean" }, ean),
                React.createElement(Price, { value: price.originalPrice, currency: currency, className: 'add-to-cart-notification__price add-to-cart-notification__price--original' +
                        (hasDiscount ? ' add-to-cart-notification__price--original-crossed' : ''), type: hasDiscount ? 'strikethrough' : 'default' }),
                hasDiscount && discountedPrice && price.discountedPrice !== null && (React.createElement(Price, { value: discountedPrice, currency: currency, className: "add-to-cart-notification__price add-to-cart-notification__price--discounted", type: "discount" })))),
        stickerText && React.createElement(DiscountBar, { title: stickerText }),
        React.createElement("div", { className: "add-to-cart-notification__footer" },
            React.createElement(Button, { href: cartRoute, variant: "solid", color: color, caption: getLabel('cart.actions.goToCart'), "data-t": "to-cart" }),
            React.createElement(Button, { variant: "outline", color: color, onClick: onClose, caption: getLabel('cart.actions.goBack'), "data-t": "continue-shopping" }))));
};

var CartBundleItem = /** @class */ (function (_super) {
    __extends(CartBundleItem, _super);
    function CartBundleItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartBundleItem.prototype.getLensParameters = function (item, eyeSide) {
        var intl = this.props.intl;
        var fields = item.custom && item.custom.fields;
        var paramsLabels = {
            basecurve: intl.getLabel('products.contactLenses.prescription.baseCurve'),
            basecurveAbbr: intl.getLabel('products.contactLenses.prescription.baseCurve.abbr'),
            diameter: intl.getLabel('products.contactLenses.prescription.diameter'),
            diameterAbbr: intl.getLabel('products.contactLenses.prescription.diameter.abbr'),
            power: intl.getLabel('products.contactLenses.prescription.power'),
            powerAbbr: intl.getLabel('products.contactLenses.prescription.power.abbr'),
            cylinder: intl.getLabel('products.contactLenses.prescription.cylinder'),
            cylinderAbbr: intl.getLabel('products.contactLenses.prescription.cylinder.abbr'),
            axis: intl.getLabel('products.contactLenses.prescription.axis'),
            axisAbbr: intl.getLabel('products.contactLenses.prescription.axis.abbr'),
        };
        return fields
            ? [
                {
                    key: paramsLabels.basecurve,
                    keyAbbr: paramsLabels.basecurveAbbr,
                    value: fields[eyeSide + "LensBaseCurve"],
                },
                {
                    key: paramsLabels.diameter,
                    keyAbbr: paramsLabels.diameterAbbr,
                    value: fields[eyeSide + "LensDiameter"],
                },
                {
                    key: paramsLabels.power,
                    keyAbbr: paramsLabels.powerAbbr,
                    value: fields[eyeSide + "LensPower"],
                },
                {
                    key: paramsLabels.cylinder,
                    keyAbbr: paramsLabels.cylinderAbbr,
                    value: fields[eyeSide + "LensCylinder"],
                },
                {
                    key: paramsLabels.axis,
                    keyAbbr: paramsLabels.axisAbbr,
                    value: fields[eyeSide + "LensAxis"],
                },
            ]
            : [];
    };
    CartBundleItem.prototype.getBundleConfiguration = function (item) {
        var intl = this.props.intl;
        var name = item.name[intl.locale];
        var lensType = getLocalizedAttrValue(item.variant, 'lensType', intl.locale);
        var isSubscription = !!getAttrValue(item.variant, 'isSubscription');
        var months = Number(getAttrValue(item.variant, 'months'));
        var fixedDiscount = Number(getAttrValue(item.variant, 'fixedDiscount'));
        var bundleItemAttributes = ['bundleProduct1', 'bundleProduct2', 'bundleProduct3'];
        var bundleProducts = bundleItemAttributes.map(function (name) { return getAttrValue(item.variant, name); });
        var leftSku = get(item, 'custom.fields.leftLensSku');
        var rightSku = get(item, 'custom.fields.rightLensSku');
        var solutionSku = get(item, 'custom.fields.solutionSku');
        var getSku = function (product) {
            return get(product, 'obj.masterData.current.masterVariant.sku');
        };
        var getName = function (product) {
            return get(product, "obj.masterData.current.name[" + intl.locale + "]");
        };
        var leftItem = bundleProducts.find(function (product) { return leftSku === getSku(product); });
        var rightItem = bundleProducts.find(function (product) { return rightSku === getSku(product); });
        var solution = bundleProducts.find(function (product) { return solutionSku === getSku(product); });
        var leftItemName = getName(leftItem);
        var rightItemName = getName(rightItem);
        var solutionName = getName(solution);
        var _a = getBundleItemImage(leftItem !== null && leftItem !== void 0 ? leftItem : rightItem, solution), itemImageUrl = _a.itemImageUrl, solutionImageUrl = _a.solutionImageUrl;
        return {
            item: {
                name: name,
                lensType: lensType,
                months: months,
                isSubscription: isSubscription,
                fixedDiscount: fixedDiscount,
                imageUrl: itemImageUrl,
            },
            leftEye: {
                name: leftItemName,
                parameters: this.getLensParameters(item, 'left'),
            },
            rightEye: {
                name: rightItemName,
                parameters: this.getLensParameters(item, 'right'),
            },
            solution: {
                name: solutionName,
                imageUrl: solutionImageUrl,
            },
        };
    };
    CartBundleItem.prototype.getLineItemPrice = function (item, showCartDiscountOnLineItem) {
        return showCartDiscountOnLineItem
            ? item.totalPrice.centAmount
            : item.price.value.centAmount * item.quantity - this.getProductDiscount(item);
    };
    CartBundleItem.prototype.getProductDiscount = function (item) {
        if (!item.price.hasOwnProperty('discounted') || item.price.discounted === undefined) {
            return 0;
        }
        return (item.price.value.centAmount - item.price.discounted.value.centAmount) * item.quantity;
    };
    CartBundleItem.prototype.getMonthsDescription = function (months, isSubscription) {
        var intl = this.props.intl;
        var subscriptionLabel = intl.getLabel('products.monthlySubscription');
        var monthLabel = intl.getLabel('products.month');
        var monthsLabel = intl.getLabel('products.months');
        if (isSubscription) {
            return subscriptionLabel;
        }
        else {
            return months ? months + " " + (months > 1 ? monthsLabel : monthLabel) : '';
        }
    };
    CartBundleItem.prototype.getBundleSlug = function () {
        var item = this.props.item;
        var parentSlug = getAttrValue(item.variant, 'parentSlug');
        if (isString(parentSlug)) {
            return parentSlug;
        }
        if (item.productSlug && item.productSlug.en) {
            return item.productSlug.en;
        }
        return '';
    };
    CartBundleItem.prototype.formatLensAttr = function (key, value) {
        if (key === 'Str') {
            return withPlusSign(this.toFixed(key, value));
        }
        return this.toFixed(key, value);
    };
    CartBundleItem.prototype.toFixed = function (key, value) {
        var ommitedKeys = ['As', 'Axis'];
        return ommitedKeys.includes(key) ? value.toString() : value.toFixed(2);
    };
    CartBundleItem.prototype.getDiscountType = function (item) {
        if (item.price.discounted &&
            item.price.discounted.discount &&
            item.price.discounted.discount.obj) {
            return item.price.discounted.discount.obj.value.type;
        }
        return 'external';
    };
    CartBundleItem.prototype.getRelativeDiscount = function (item) {
        if (item.price.discounted) {
            return Math.round(100 * (1 - item.price.discounted.value.centAmount / item.price.value.centAmount));
        }
        return 0;
    };
    CartBundleItem.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, productRoute = _a.productRoute, originalPrice = _a.originalPrice, discount = _a.discount, readOnly = _a.readOnly, showCartDiscountOnLineItem = _a.showCartDiscountOnLineItem, onRemoveCartLineItem = _a.onRemoveCartLineItem, intl = _a.intl;
        var productType = (item.productType && item.productType.obj && item.productType.obj.name) || '';
        var brand = getLocalizedAttrValue(item.variant, 'brand', intl.locale);
        var brandModel = getLocalizedAttrValue(item.variant, 'brandModel', intl.locale);
        var bundleSlug = this.getBundleSlug();
        var bundle = this.getBundleConfiguration(item);
        var montshDescription = this.getMonthsDescription(bundle.item.months, bundle.item.isSubscription);
        var isDiscount = discount > 0;
        var relativeDiscount = this.getRelativeDiscount(item);
        return (React.createElement("div", { className: "cart-bundle-item cart-line-item cart-line-item--" + (productType && productType.toLowerCase()) },
            React.createElement("div", { className: "cart-line-item__bundle-container" },
                React.createElement("div", { className: "cart-line-item__bundle-item" },
                    readOnly ? (React.createElement("div", { className: "cart-line-item__image-link" },
                        React.createElement("img", { className: "cart-line-item__image", src: bundle.item.imageUrl, alt: brand + " " + brandModel }))) : (React.createElement("a", { className: "cart-line-item__image-link", href: productRoute.route + "/" + bundleSlug },
                        React.createElement("img", { className: "cart-line-item__image", src: bundle.item.imageUrl, alt: brand + " " + brandModel }))),
                    React.createElement("div", { className: "cart-line-item__content" },
                        React.createElement("div", { className: "cart-line-item__description" },
                            React.createElement(Heading, { variant: "medium", className: "cart-line-item__title" }, bundle.item.name),
                            React.createElement("div", { className: "cart-line-item__lens-type" }, bundle.item.lensType),
                            readOnly && (React.createElement("div", { className: "cart-line-item__months-description" }, montshDescription)),
                            this.getDiscountType(item) !== 'external' && (React.createElement("div", { className: "cart-line-item__discount" },
                                React.createElement("span", { className: "cart-line-item__discount-text" }, this.getDiscountType(item) === 'relative' &&
                                    relativeDiscount > 0 &&
                                    intl.getLabel('cart.item.discount') + " " + relativeDiscount + "%"),
                                this.getDiscountType(item) === 'absolute' && discount > 0 && (React.createElement(React.Fragment, null,
                                    intl.getLabel('cart.item.discount'),
                                    ' ',
                                    React.createElement(Price, { value: discount, currency: intl.currency, className: "cart-line-item__discount-price" })))))),
                        React.createElement("div", { className: "cart-line-item__quantity-and-price" },
                            !readOnly && (React.createElement("div", { className: "cart-line-item__quantity" },
                                React.createElement("div", { className: "cart-line-item__quantity-selector" },
                                    onRemoveCartLineItem && (React.createElement("div", { className: "cart-line-item__delete-btn" },
                                        React.createElement(IconButton, { onClick: function () { return onRemoveCartLineItem(item); } },
                                            React.createElement(Icon, { name: "trash" })))),
                                    React.createElement("div", { className: "cart-line-item__months-description--read-only" }, montshDescription)))),
                            originalPrice && (React.createElement("div", { className: "cart-line-item__price" },
                                discount > 0 && (React.createElement("span", { className: "cart-line-item__discount-amount" },
                                    React.createElement(Price, { value: originalPrice, currency: intl.currency, type: "strikethrough" }))),
                                item.totalPrice.centAmount && item.totalPrice.centAmount !== 0 ? (React.createElement("span", { className: classnames({
                                        'cart-line-item__price': !isDiscount,
                                        'cart-line-item__price--discount': isDiscount,
                                    }) },
                                    React.createElement(Price, { value: this.getLineItemPrice(item, showCartDiscountOnLineItem), currency: intl.currency, type: isDiscount ? 'discount' : 'default' }))) : (React.createElement("span", { className: "cart-line-item__price--discount" }, intl.getLabel('products.freeProduct', { defaultValue: '0' })))))))),
                bundle.leftEye.name && (React.createElement("div", { className: "cart-line-item__bundle-item" },
                    React.createElement("div", { className: "cart-line-item__image-link" },
                        React.createElement("div", { className: "cart-line-item__lens-icon" },
                            React.createElement(Icon, { name: "left-eye", width: 48, height: 48 }),
                            React.createElement("span", { className: "cart-line-item__eye-label mobile-hidden" }, intl.getLabel('products.contactLenses.leftEye')))),
                    React.createElement("div", { className: "cart-line-item__content" },
                        React.createElement("div", { className: "cart-line-item__description cart-line-item__description--no-price" },
                            React.createElement("div", { className: "cart-line-item__item-title" }, bundle.leftEye.name),
                            React.createElement("div", { className: "cart-line-item__lens-params-list mobile-hidden" }, bundle.leftEye.parameters.map(function (param) {
                                return param.value !== undefined ? (React.createElement("div", { key: param.key, className: "cart-line-item__lens-param" },
                                    React.createElement("span", { className: "cart-line-item__lens-param-name" }, param.key),
                                    React.createElement("span", { className: "cart-line-item__lens-param-value" }, _this.formatLensAttr(param.keyAbbr, param.value)))) : null;
                            })),
                            React.createElement("div", { className: "cart-line-item__lens-params-list desktop-hidden" }, bundle.leftEye.parameters.map(function (param) {
                                return param.value !== undefined ? (React.createElement("div", { key: param.keyAbbr, className: "cart-line-item__lens-param" },
                                    React.createElement("span", { className: "cart-line-item__lens-param-name" }, param.keyAbbr),
                                    React.createElement("span", { className: "cart-line-item__lens-param-value" }, _this.formatLensAttr(param.keyAbbr, param.value)))) : null;
                            })))))),
                bundle.rightEye.name && (React.createElement("div", { className: "cart-line-item__bundle-item" },
                    React.createElement("div", { className: "cart-line-item__image-link cart-line-item__image-link--disabled" },
                        React.createElement("div", { className: "cart-line-item__lens-icon" },
                            React.createElement(Icon, { name: "right-eye", width: 48, height: 48 }),
                            React.createElement("span", { className: "cart-line-item__eye-label mobile-hidden" }, intl.getLabel('products.contactLenses.rightEye')))),
                    React.createElement("div", { className: "cart-line-item__content" },
                        React.createElement("div", { className: "cart-line-item__description cart-line-item__description--no-price" },
                            React.createElement("div", { className: "cart-line-item__item-title" }, bundle.rightEye.name),
                            React.createElement("div", { className: "cart-line-item__lens-params-list mobile-hidden" }, bundle.rightEye.parameters.map(function (param) {
                                return param.value !== undefined ? (React.createElement("div", { key: param.key, className: "cart-line-item__lens-param" },
                                    React.createElement("span", { className: "cart-line-item__lens-param-name" }, param.key),
                                    React.createElement("span", { className: "cart-line-item__lens-param-value" }, _this.formatLensAttr(param.keyAbbr, param.value)))) : null;
                            })),
                            React.createElement("div", { className: "cart-line-item__lens-params-list desktop-hidden" }, bundle.rightEye.parameters.map(function (param) {
                                return param.value !== undefined ? (React.createElement("div", { key: param.keyAbbr, className: "cart-line-item__lens-param" },
                                    React.createElement("span", { className: "cart-line-item__lens-param-name" }, param.keyAbbr),
                                    React.createElement("span", { className: "cart-line-item__lens-param-value" }, _this.formatLensAttr(param.keyAbbr, param.value)))) : null;
                            })))))),
                bundle.solution.name && (React.createElement("div", { className: "cart-line-item__bundle-item" },
                    React.createElement("div", { className: "cart-line-item__image-link cart-line-item__image-link--disabled" },
                        React.createElement("img", { className: "cart-line-item__image", src: bundle.solution.imageUrl, alt: brand + " " + brandModel })),
                    React.createElement("div", { className: "cart-line-item__content" },
                        React.createElement("div", { className: "cart-line-item__description cart-line-item__description--no-price" },
                            React.createElement("div", { className: "cart-line-item__item-title" }, bundle.solution.name))))))));
    };
    return CartBundleItem;
}(React.PureComponent));
var CartBundleItem$1 = withIntl(CartBundleItem);

var CartLineItem = /** @class */ (function (_super) {
    __extends(CartLineItem, _super);
    function CartLineItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formatUrl = function () {
            var _a = _this.props, formatProductUrl = _a.formatProductUrl, item = _a.item;
            if (!item.productType.obj) {
                return '#';
            }
            return formatProductUrl({
                productType: item.productType.obj.name,
                sku: item.variant.sku,
                slug: item.productSlug,
            });
        };
        return _this;
    }
    CartLineItem.prototype.getProductDiscount = function (item) {
        if (!item.price.hasOwnProperty('discounted') || item.price.discounted === undefined) {
            return 0;
        }
        return (item.price.value.centAmount - item.price.discounted.value.centAmount) * item.quantity;
    };
    CartLineItem.prototype.getDiscount = function (item) {
        return this.getOriginalPrice(item) - this.getLineItemPrice(item);
    };
    CartLineItem.prototype.getOriginalPrice = function (item) {
        return item.price.value.centAmount * item.quantity;
    };
    CartLineItem.prototype.getLineItemTitle = function (item, productType) {
        var intl = this.props.intl;
        if (CommerceToolsApi.isSunglasses(productType)) {
            return String(getAttrValue(item.variant, 'brand'));
        }
        return getLocalizedValue(item.name, intl.locale);
    };
    CartLineItem.prototype.getLineItemPrice = function (item) {
        return this.props.showCartDiscountOnLineItem
            ? item.totalPrice.centAmount
            : item.price.value.centAmount * item.quantity - this.getProductDiscount(item);
    };
    CartLineItem.prototype.getDiscountType = function (item) {
        if (item.price.discounted &&
            item.price.discounted.discount &&
            item.price.discounted.discount.obj) {
            return item.price.discounted.discount.obj.value.type;
        }
        return '';
    };
    CartLineItem.prototype.getRelativeDiscount = function (item) {
        if (item.price.discounted) {
            return Math.round(100 * (1 - item.price.discounted.value.centAmount / item.price.value.centAmount)) + "%";
        }
        return '';
    };
    CartLineItem.prototype.render = function () {
        var _a = this.props, item = _a.item, imageUrl = _a.imageUrl, readOnly = _a.readOnly, onRemoveCartLineItem = _a.onRemoveCartLineItem, onDecrement = _a.onDecrement, onIncrement = _a.onIncrement, productRoutes = _a.productRoutes, minimumQuantity = _a.minimumQuantity, maximumQuantity = _a.maximumQuantity, showCartDiscountOnLineItem = _a.showCartDiscountOnLineItem, multiDiscountType = _a.multiDiscountType, intl = _a.intl, hideStockAndDeliveryOnLineItem = _a.hideStockAndDeliveryOnLineItem, stockResolver = _a.stockResolver, deliveryResolver = _a.deliveryResolver;
        var eyeSide = item.custom && item.custom.fields.eyeSide;
        var contentLabel = eyeSide === 'left' ? 'contactLenses.leftEye' : 'contactLenses.rightEye';
        var productType = (item.productType && item.productType.obj && item.productType.obj.name) || '';
        var lineItemTitle = this.getLineItemTitle(item, productType);
        var absoluteDiscount = showCartDiscountOnLineItem
            ? this.getDiscount(item)
            : this.getProductDiscount(item);
        var originalPrice = this.getOriginalPrice(item);
        var productRoute = (productRoutes && productRoutes.find(function (route) { return route.productType === productType; })) || {};
        var lensAttr = item.variant.attributes || [];
        var brandAttrValue = getAttrValue(item.variant, 'brand');
        var brandModelAttrValue = getAttrValue(item.variant, 'brandModel');
        var brandModelCodeAttrValue = getAttrValue(item.variant, 'brandModelCode');
        var brand = isString(brandAttrValue) ? brandAttrValue : undefined;
        var brandModel = isString(brandModelAttrValue) ? brandModelAttrValue : undefined;
        var brandModelCode = isString(brandModelCodeAttrValue) ? brandModelCodeAttrValue : undefined;
        var packageQuantity = String(getAttrValue(item.variant, 'packageQuantity'));
        var volume = Number(getAttrValue(item.variant, 'volume'));
        var solutionType = getAttrValue(item.variant, 'solutionType');
        var replacementFrequency = getLocalizedAttrValue(item.variant, 'replacementFrequency', intl.locale);
        var colorLens = getAttrValue(item.variant, 'color');
        var specs = lensAttr.filter(function (_a) {
            var name = _a.name;
            return (name === 'baseCurve' ||
                name === 'diameter' ||
                name === 'axis' ||
                name === 'power' ||
                name === 'cylinder' ||
                name === 'addition');
        });
        var availableQuantity = Helpers.getAvailableQuantity(item.variant.availability);
        var allowBackOrderAttribute = getAttrValue(item.variant, 'allowBackOrder');
        var allowBackOrder = typeof allowBackOrderAttribute === 'boolean'
            ? allowBackOrderAttribute
            : this.props.allowBackOrder;
        var calculatedMaxQuantity = availableQuantity && (!maximumQuantity || availableQuantity < maximumQuantity)
            ? availableQuantity
            : maximumQuantity;
        return CommerceToolsApi.isContactLensBundle(productType) ? (React.createElement(CartBundleItem$1, { item: item, productRoute: productRoute, originalPrice: originalPrice, discount: absoluteDiscount, readOnly: readOnly, showCartDiscountOnLineItem: showCartDiscountOnLineItem, onRemoveCartLineItem: onRemoveCartLineItem })) : (React.createElement("div", { className: "cart-line-item cart-line-item--" + (productType && productType.toLowerCase()) },
            readOnly || CommerceToolsApi.isSolutions(productType) ? (React.createElement("div", { className: "cart-line-item__image-link cart-line-item__image-link--disabled" },
                CommerceToolsApi.isLenses(productType) && (React.createElement("div", { className: "cart-line-item__lens-icon" },
                    React.createElement(Icon, { name: eyeSide + '-eye', width: 48, height: 48 }),
                    React.createElement("span", { className: "cart-line-item__eye-label mobile-hidden" }, intl.getLabel("products." + contentLabel)))),
                React.createElement("img", { className: "cart-line-item__image", src: imageUrl, alt: brand + " " + brandModel }))) : (React.createElement("a", { className: "cart-line-item__image-link", href: this.formatUrl() },
                CommerceToolsApi.isLenses(productType) && (React.createElement("div", { className: "cart-line-item__lens-icon" },
                    React.createElement(Icon, { name: eyeSide + '-eye', width: 48, height: 48 }),
                    React.createElement("span", { className: "cart-line-item__eye-label mobile-hidden" }, intl.getLabel("products." + contentLabel)))),
                React.createElement("img", { className: "cart-line-item__image", src: imageUrl, alt: brand + " " + brandModel }))),
            React.createElement("div", { className: "cart-line-item__content" },
                React.createElement("div", { className: "cart-line-item__description" },
                    React.createElement(Heading, { variant: "medium", className: "cart-line-item__title" }, lineItemTitle),
                    React.createElement("span", { className: "cart-line-item__article-number" },
                        brandModel,
                        brandModelCode && brandModelCode !== brandModel ? " " + brandModelCode : null)),
                React.createElement("div", { className: "cart-line-item__quantity-and-price" },
                    !readOnly && item.lineItemMode !== CommerceToolsApi.LineItemMode.GiftLineItem && (React.createElement("div", { className: "cart-line-item__quantity" },
                        React.createElement("div", { className: "cart-line-item__quantity-selector" },
                            onRemoveCartLineItem && (React.createElement("div", { className: "cart-line-item__delete-btn" },
                                React.createElement(LineItemDeleteButton, { onClick: function () { return onRemoveCartLineItem(item); } }))),
                            onDecrement && onIncrement && item.quantity && (React.createElement(QuantitySelector, { onDecreaseQuantity: function () { return onDecrement(item); }, onIncreaseQuantity: function () { return onIncrement(item); }, quantity: item.quantity, minimumQuantity: minimumQuantity, maximumQuantity: calculatedMaxQuantity }))))),
                    originalPrice && (React.createElement("div", { className: "cart-line-item__price" },
                        absoluteDiscount > 0 && (React.createElement(Price, { value: originalPrice, currency: intl.currency, className: "cart-line-item__discount-amount", type: "strikethrough" })),
                        item.totalPrice.centAmount && item.totalPrice.centAmount !== 0 ? (React.createElement(Price, { value: this.getLineItemPrice(item), currency: intl.currency, type: absoluteDiscount > 0 ? 'discount' : 'default' })) : (React.createElement("span", { className: "cart-line-item__price--discount" }, intl.getLabel('products.freeProduct', { defaultValue: '0' })))))),
                React.createElement("div", { className: "cart-line-item__specs-and-stock" },
                    React.createElement("div", { className: "cart-line-item__specs" },
                        CommerceToolsApi.isLenses(productType) && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "cart-line-item__contact-lens-meta" },
                                colorLens && React.createElement("span", { className: "cart-line-item__color-lens" }, colorLens),
                                replacementFrequency && (React.createElement("span", { className: "cart-line-item__replacement-frequency" }, replacementFrequency)),
                                packageQuantity && (React.createElement("span", { className: "cart-line-item__amount-lenses-per-box" }, packageQuantity + " " + intl.getLabel('products.unit.contactLenses') + " " + intl.getLabel('products.perBox')))),
                            React.createElement("div", { className: "cart-line-item__spec-box mobile-hidden" }, specs.map(function (spec) { return (React.createElement("span", { className: "cart-line-item__spec", key: spec.name },
                                React.createElement("span", { className: "cart-line-item__spec-key" }, intl.getLabel("products.contactLenses.prescription." + spec.name)),
                                React.createElement("span", { className: "cart-line-item__spec-value" },
                                    spec.value,
                                    " "))); })),
                            React.createElement("div", { className: "cart-line-item__spec-box desktop-hidden" }, specs.map(function (spec) { return (React.createElement("span", { className: "cart-line-item__spec", key: spec.name },
                                React.createElement("span", { className: "cart-line-item__spec-key" }, intl.getLabel("products.contactLenses.prescription." + spec.name + ".abbr")),
                                React.createElement("span", { className: "cart-line-item__spec-value" },
                                    spec.value,
                                    " "))); })))),
                        CommerceToolsApi.isSolutions(productType) && (React.createElement(React.Fragment, null,
                            solutionType && (React.createElement(React.Fragment, null,
                                React.createElement("span", { className: "cart-line-item__solution-type" }, solutionType),
                                ",",
                                ' ')),
                            volume && (React.createElement("span", { className: "cart-line-item__volume" },
                                volume,
                                " ",
                                intl.getLabel('products.unit.metric.liter.milli.abbr')))))),
                    !hideStockAndDeliveryOnLineItem && (React.createElement("div", { className: "cart-line-item__stock-and-delivery" },
                        React.createElement("div", { className: "cart-line-item__delivery" }, !readOnly && (React.createElement(DeliveryIndicator, { view: "short", availability: item.variant.availability ? [item.variant.availability] : [], deliveryResolver: deliveryResolver }))),
                        React.createElement("div", { className: "cart-line-item__stock" }, !readOnly && (React.createElement(StockIndicator, { stockCount: availableQuantity, allowBackOrder: allowBackOrder, stockResolver: stockResolver })))))),
                readOnly && (React.createElement("span", { className: "cart-line-item__count" },
                    intl.getLabel('cart.item.quantity'),
                    ": ",
                    item.quantity)),
                absoluteDiscount > 0 && (React.createElement("div", { className: "cart-line-item__discount" },
                    React.createElement("span", { className: "cart-line-item__discount-text" },
                        intl.getLabel('cart.item.discount'),
                        "\u00A0",
                        multiDiscountType &&
                            this.getDiscountType(item) === 'relative' &&
                            this.getRelativeDiscount(item)),
                    (!multiDiscountType || this.getDiscountType(item) === 'absolute') && (React.createElement(Price, { value: absoluteDiscount, currency: intl.currency, className: "cart-line-item__discount-price" })))))));
    };
    CartLineItem.defaultProps = {
        showCartDiscountOnLineItem: true,
        multiDiscountType: false,
        hideStockAndDeliveryOnLineItem: false,
    };
    return CartLineItem;
}(React.Component));
var CartLineItem$1 = withIntl(CartLineItem);

var LineItemImage = function (_a) {
    var className = _a.className, href = _a.href, imageAlt = _a.imageAlt, imageUrl = _a.imageUrl, rest = __rest(_a, ["className", "href", "imageAlt", "imageUrl"]);
    if (href) {
        return (React.createElement("a", { className: classnames('line-item-image', className), href: href, "data-t": rest['data-t'] },
            React.createElement("img", { className: "line-item-image__image", src: imageUrl, alt: imageAlt })));
    }
    return (React.createElement("div", { className: classnames('line-item-image', className), "data-t": rest['data-t'] },
        React.createElement("img", { className: "line-item-image__image", src: imageUrl, alt: imageAlt })));
};

var getLineItemCartDiscount = function (lineItem, locale) {
    var _a, _b, _c;
    if (!((_a = lineItem.discountedPrice) === null || _a === void 0 ? void 0 : _a.includedDiscounts) ||
        lineItem.discountedPrice.includedDiscounts.length === 0) {
        return undefined;
    }
    /*
     * ----- Get the discount description -----
     * Find the description for the first cart discount in the lineItem list of included discounts
     */
    var discount = (((_b = lineItem.discountedPrice.includedDiscounts) === null || _b === void 0 ? void 0 : _b.find(function (_a) {
        var discount = _a.discount;
        return (discount === null || discount === void 0 ? void 0 : discount.typeId) === 'cart-discount';
    })) || {}).discount;
    var description = ((_c = discount === null || discount === void 0 ? void 0 : discount.obj) === null || _c === void 0 ? void 0 : _c.description)
        ? getLocalizedValue(discount.obj.description, locale)
        : undefined;
    /*
     * ----- Get the total amount of the cart discount -----
     * Add up all cart discounts for every item in discountedPricePerQuantity * the quantity of items with that discount
     */
    var totalCartDiscount = 0;
    lineItem.discountedPricePerQuantity.forEach(function (_a) {
        var discountedPrice = _a.discountedPrice, quantity = _a.quantity;
        discountedPrice.includedDiscounts.forEach(function (_a) {
            var discount = _a.discount, discountedAmount = _a.discountedAmount;
            if ((discount === null || discount === void 0 ? void 0 : discount.typeId) === 'cart-discount') {
                totalCartDiscount += discountedAmount.centAmount * quantity;
            }
        });
    });
    return {
        discountedAmount: totalCartDiscount,
        description: description,
    };
};

var getTotalProductDiscount = function (price, quantity) {
    var value = price.value, discounted = price.discounted;
    if (!!discounted) {
        return Math.abs(value.centAmount - discounted.value.centAmount) * quantity;
    }
    else {
        return 0;
    }
};

function toLineItemPrescription(prescription) {
    if (!isDefined(prescription))
        return undefined;
    switch (prescription.type) {
        case 'PrescriptionFile':
            return {
                type: Types.PrescriptionType.PRESCRIPTION_FILE,
                prescriptionFile: prescription.uploadedPrescriptionFile.fileName,
                pupillaryDistanceFile: prescription.uploadedPupillaryDistanceFile.fileName,
            };
        case 'NewPrescription':
            return {
                type: Types.PrescriptionType.NEW_PRESCRIPTION,
                rightLens: prescription.rightLens,
                leftLens: prescription.leftLens,
            };
        default:
            return {
                type: Types.PrescriptionType[prescription.type],
            };
    }
}

var classPrefix = 'prescription-glasses-cart-line-item';
function getBundleChildLineItemTitle(childLineItem, locale) {
    var variant = childLineItem.variant;
    var variationAttribute = getAttrValue(variant, 'variationAttribute');
    var addOnTitle = getLocalizedValue(childLineItem.name, locale);
    if (variationAttribute && isString(variationAttribute)) {
        var variationAttributeValue = getLocalizedAttrValue(variant, variationAttribute, locale);
        return addOnTitle + " - " + variationAttributeValue;
    }
    else {
        return addOnTitle;
    }
}
var PrescriptionGlassesCartLineItem = function (_a) {
    var _b, _c, _d, _e, _f;
    var className = _a.className, readOnly = _a.readOnly, imageUrl = _a.imageUrl, prescriptionGlassesLineItem = _a.prescriptionGlassesLineItem, onRemoveCartLineItem = _a.onRemoveCartLineItem, formatProductUrl = _a.formatProductUrl, onIncrement = _a.onIncrement, onDecrement = _a.onDecrement, maximumQuantity = _a.maximumQuantity, rest = __rest(_a, ["className", "readOnly", "imageUrl", "prescriptionGlassesLineItem", "onRemoveCartLineItem", "formatProductUrl", "onIncrement", "onDecrement", "maximumQuantity"]);
    var _g = useIntl(), currency = _g.currency, getLabel = _g.getLabel, locale = _g.locale;
    var isPhone = MediaQuery.useIsPhone();
    var bundleChildLineItems = prescriptionGlassesLineItem.bundleChildLineItems, bundleMainLineItem = prescriptionGlassesLineItem.bundleMainLineItem, price = prescriptionGlassesLineItem.price, prescription = prescriptionGlassesLineItem.prescription, totalPrice = prescriptionGlassesLineItem.totalPrice, quantity = prescriptionGlassesLineItem.quantity;
    var brand = bundleMainLineItem.brand, brandModel = bundleMainLineItem.brandModel, brandModelCode = bundleMainLineItem.brandModelCode, brandModelColorCode = bundleMainLineItem.brandModelColorCode, variant = bundleMainLineItem.variant, productType = bundleMainLineItem.productType, slug = bundleMainLineItem.slug, framePrice = bundleMainLineItem.price;
    var productDiscount = getTotalProductDiscount(price, quantity);
    var cartDiscount = React.useMemo(function () { return getLineItemCartDiscount(prescriptionGlassesLineItem, locale); }, [prescriptionGlassesLineItem, locale]);
    var totalDiscount = productDiscount + ((_b = cartDiscount === null || cartDiscount === void 0 ? void 0 : cartDiscount.discountedAmount) !== null && _b !== void 0 ? _b : 0);
    var isFree = totalPrice.centAmount === 0;
    var itemName = React.useMemo(function () {
        return [brand, brandModel, brandModelCode, brandModelColorCode].reduce(function (acc, value, i, arr) {
            var prev = arr[i - 1]; // make sure we don't concat identical values
            return !!value && value !== prev ? acc + " " + value : acc;
        }, '');
    }, [brand, brandModel, brandModelCode, brandModelColorCode]);
    var href = React.useMemo(function () {
        return formatProductUrl({
            slug: slug,
            productType: productType,
            sku: variant.sku,
        });
    }, [slug, productType, variant.sku]);
    var onDeleteClick = React.useCallback(function () {
        onRemoveCartLineItem && onRemoveCartLineItem(prescriptionGlassesLineItem);
    }, [onRemoveCartLineItem, prescriptionGlassesLineItem]);
    var onIncrementClick = React.useCallback(function () {
        onIncrement && onIncrement(prescriptionGlassesLineItem);
    }, [onIncrement, prescriptionGlassesLineItem]);
    var onDecrementClick = React.useCallback(function () {
        onDecrement && onDecrement(prescriptionGlassesLineItem);
    }, [onDecrement, prescriptionGlassesLineItem]);
    return (React.createElement("div", { className: classnames(classPrefix, className), "data-t": rest['data-t'] },
        !isPhone && (React.createElement(LineItemImage, { imageUrl: imageUrl, imageAlt: itemName, className: classPrefix + "__image", href: href })),
        React.createElement("div", { className: classPrefix + "__content" },
            React.createElement("div", { className: classPrefix + "__row" },
                React.createElement("div", { className: classPrefix + "__row-item " + classPrefix + "__title-wrapper" },
                    isPhone && (React.createElement(LineItemImage, { className: classPrefix + "__image", imageUrl: imageUrl, imageAlt: itemName, href: href })),
                    React.createElement(Heading, { className: classPrefix + "__title", variant: "smallest", component: "h3" }, itemName)),
                React.createElement("div", { className: classPrefix + "__frame-price-wrapper" },
                    ((_c = framePrice.discounted) === null || _c === void 0 ? void 0 : _c.value) && (React.createElement(Price, { type: "strikethrough", currency: currency, value: framePrice.value.centAmount, className: classPrefix + "__frame-price" })),
                    React.createElement(Price, { currency: currency, value: (_e = (_d = framePrice.discounted) === null || _d === void 0 ? void 0 : _d.value.centAmount) !== null && _e !== void 0 ? _e : framePrice.value.centAmount, type: ((_f = framePrice.discounted) === null || _f === void 0 ? void 0 : _f.value) ? 'discount' : 'default', className: classPrefix + "__frame-price" }))),
            React.createElement(LineItemGlassesPrescription, { className: classPrefix + "__prescription", prescription: toLineItemPrescription(prescription) }),
            bundleChildLineItems.map(function (item) {
                var _a, _b, _c, _d;
                var discountDescription = (_c = (_b = (_a = item.price.discounted) === null || _a === void 0 ? void 0 : _a.discount) === null || _b === void 0 ? void 0 : _b.obj) === null || _c === void 0 ? void 0 : _c.description;
                var discountText = discountDescription
                    ? getLocalizedValue(discountDescription, locale)
                    : undefined;
                return (React.createElement(LineItemBundleRow, { key: item.productId, currency: currency, originalPrice: item.price.value.centAmount, discountedPrice: (_d = item.price.discounted) === null || _d === void 0 ? void 0 : _d.value.centAmount, title: getLabel("cart.lineItem.glasses.bundleItem." + item.productType), discountText: discountText, body: getBundleChildLineItemTitle(item, locale) }));
            }),
            cartDiscount && cartDiscount.discountedAmount > 0 && (React.createElement("div", { className: classPrefix + "__row" },
                React.createElement("div", { className: classPrefix + "__row-item " + classPrefix + "__cart-discount" },
                    React.createElement("span", { className: classPrefix + "__cart-discount-text" }, cartDiscount.description)),
                React.createElement(Price, { value: -cartDiscount.discountedAmount, currency: currency, type: "discount" }))),
            React.createElement("div", { className: classPrefix + "__row" },
                React.createElement("div", { className: classPrefix + "__row-item " + classPrefix + "__total-price-wrapper" },
                    onRemoveCartLineItem && !readOnly && (React.createElement("div", { className: classPrefix + "__delete-btn" },
                        React.createElement(LineItemDeleteButton, { "data-t": classPrefix + "-delete", onClick: onDeleteClick }))),
                    onDecrement && onIncrement && !readOnly && prescriptionGlassesLineItem.quantity && (React.createElement(QuantitySelector, { onDecreaseQuantity: onDecrementClick, onIncreaseQuantity: onIncrementClick, quantity: prescriptionGlassesLineItem.quantity, maximumQuantity: maximumQuantity })),
                    isFree ? (React.createElement("span", { className: classPrefix + "__is-free-label" }, getLabel('common.free'))) : (React.createElement(Price, { value: totalPrice.centAmount, currency: currency, size: isPhone ? 'small' : 'medium' })))),
            React.createElement("div", { className: classPrefix + "__row" },
                React.createElement("span", { className: classPrefix + "__savings" }, totalDiscount > 0 && (React.createElement(React.Fragment, null,
                    getLabel('cart.item.discount'),
                    ' ',
                    React.createElement(Price, { value: totalDiscount, currency: currency, className: classPrefix + "__saved-amount" }))))))));
};

var getCart$1 = function (state) { return state.cart; };
var getCartResult = createSelector(getCart$1, function (cart) {
    return cart && !statusUninit(cart) && !statusLoading(cart) && !statusFailed(cart) && !!cart.result
        ? cart.result
        : undefined;
});
// Checks if cart is valid for checkout
var isCartResultValid = createSelector(getCartResult, function (cart) {
    return !!cart &&
        !!cart.id &&
        !!cart.version &&
        !!cart.country &&
        !!cart.totalPrice &&
        !!cart.shippingInfo &&
        !isEmptyCart(cart) &&
        cart.cartState === 'Active';
});
// Returns an array of productType strings that are present in the current cart state
var getCartProductTypes = createSelector(getCartResult, function (cart) { return getProductTypeNames(cart); });
var cartContainsContactLenses = createSelector(getCartProductTypes, function (cartProductTypes) { return cartProductTypes.includes('Contact-lenses'); });
var cartContainsPrescriptionGlasses = createSelector(getCartResult, function (cart) { return hasPrescriptionGlassesInCart(cart); });
var cartContainsSolutions = createSelector(getCartProductTypes, function (cartProductTypes) { return cartProductTypes.includes('Solutions'); });
var cartContainsSubscription = createSelector(getCartResult, function (cart) {
    return !!cart &&
        cart.lineItems &&
        cart.lineItems.some(function (item) { return !!getAttrValue(item.variant, 'isSubscription'); });
});
var cartContainsSunglasses = createSelector(getCartProductTypes, function (cartProductTypes) { return cartProductTypes.includes('Sunglasses'); });
var cartContainsContactLensesSubscription = createSelector(getCartResult, function (cart) { return hasContactLensesSubscriptionInCart(cart); });
var cartContainsReadyReaders = createSelector(getCartProductTypes, function (cartProductTypes) { return cartProductTypes.includes('Ready-readers'); });
// Checks if the cart contains any lineItems
var isCartEmpty = createSelector(getCartResult, function (cart) { return !cart || isEmptyCart(cart); });
// Return the discountCodes attached to the cart
var getDiscountCodes = createSelector(getCartResult, function (cart) {
    return cart && cart.discountCodes ? cart.discountCodes : [];
});
// Returns the discountCodes in a mapped format which can be used by the Cart
var getAppliedDiscountCodes = createSelector(getDiscountCodes, function (discountCodes) {
    return discountCodes.reduce(function (prev, code) {
        var id = code.discountCode.id;
        var name = code.discountCode.obj && code.discountCode.obj.code;
        var state = code.state;
        if (name && state) {
            prev.push({ id: id, name: name, state: state });
        }
        return prev;
    }, []);
});

var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCart: getCart$1,
  getCartResult: getCartResult,
  isCartResultValid: isCartResultValid,
  getCartProductTypes: getCartProductTypes,
  cartContainsContactLenses: cartContainsContactLenses,
  cartContainsPrescriptionGlasses: cartContainsPrescriptionGlasses,
  cartContainsSolutions: cartContainsSolutions,
  cartContainsSubscription: cartContainsSubscription,
  cartContainsSunglasses: cartContainsSunglasses,
  cartContainsContactLensesSubscription: cartContainsContactLensesSubscription,
  cartContainsReadyReaders: cartContainsReadyReaders,
  isCartEmpty: isCartEmpty,
  getDiscountCodes: getDiscountCodes,
  getAppliedDiscountCodes: getAppliedDiscountCodes
});

var isPrescriptionGlassesLineItem = CommerceToolsApi.isPrescriptionGlassesLineItem;
var Cart = /** @class */ (function (_super) {
    __extends(Cart, _super);
    function Cart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.updateQuantity = function (lineItem, newQuantity) {
            var formatProductUrl = _this.props.formatProductUrl;
            _this.props.changeQuantity({
                lineItem: isPrescriptionGlassesLineItem(lineItem) ? undefined : lineItem,
                newQuantity: newQuantity,
                formatProductUrl: formatProductUrl,
                prescriptionGlassesLineItem: isPrescriptionGlassesLineItem(lineItem) ? lineItem : undefined,
            });
        };
        _this.onDecrement = function (lineItem) {
            var newQuantity = lineItem.quantity - 1;
            _this.updateQuantity(lineItem, newQuantity);
        };
        _this.onIncrement = function (lineItem) {
            var newQuantity = lineItem.quantity + 1;
            _this.updateQuantity(lineItem, newQuantity);
        };
        _this.onRemoveCartLineItem = function (lineItem) {
            var formatProductUrl = _this.props.formatProductUrl;
            _this.props.removeLineItems({
                lineItems: [lineItem],
                formatProductUrl: formatProductUrl,
            });
        };
        _this.onRemoveCustomCartLineItem = function (customLineItem) {
            var formatProductUrl = _this.props.formatProductUrl;
            _this.props.removeCustomLineItems({
                lineItems: [customLineItem],
                formatProductUrl: formatProductUrl,
            });
        };
        _this.onApplyDiscountCode = function (discountCode) {
            _this.props.addDiscountCode({ discountCode: discountCode });
        };
        _this.onRemoveDiscountCode = function (removedDiscountCode) {
            _this.props.removeDiscountCode({
                discountCodeId: removedDiscountCode.id,
            });
        };
        _this.onGoBack = function () {
            if (document.referrer === window.location.href) {
                window.location.href = '/';
            }
            window.location.host === document.referrer.split('/')[2]
                ? window.history.back()
                : (window.location.href = '/');
        };
        _this.getOriginalTotal = function () {
            var cart = _this.props.cart;
            // TODO: write better selectors for this
            if (statusUninit(cart) || statusLoading(cart) || statusFailed(cart) || !cart || !cart.result) {
                console.error('Something went wrong loading the cart!');
                return 0;
            }
            var _a = cart.result, lineItems = _a.lineItems, _b = _a.prescriptionGlassesLineItems, prescriptionGlassesLineItems = _b === void 0 ? [] : _b;
            var subtotal = __spreadArray(__spreadArray([], __read(lineItems)), __read((prescriptionGlassesLineItems || []))).reduce(function (sum, _a) {
                var price = _a.price, quantity = _a.quantity;
                return sum + quantity * price.value.centAmount;
            }, 0);
            return subtotal;
        };
        _this.getCartDiscountDescriptions = function () {
            var _a = _this.props, cart = _a.cart, intl = _a.intl;
            if (statusUninit(cart) || statusLoading(cart) || statusFailed(cart) || !cart || !cart.result) {
                return null;
            }
            var discountTargetPaths = ['shippingInfo', 'lineItems'];
            var discountDescriptions = new Set();
            discountTargetPaths.forEach(function (discountTargetPath) {
                var target = get(cart.result, discountTargetPath);
                var targets = target && Array.isArray(target) ? target : [target];
                targets &&
                    targets.forEach(function (target) {
                        var discounts = get(target, 'discountedPrice.includedDiscounts');
                        discounts &&
                            discounts.forEach(function (discount) {
                                // filter out discounts that require a discount code
                                if (get(discount, 'discount.obj.requiresDiscountCode')) {
                                    return;
                                }
                                var description = getLocalizedValue(get(discount, 'discount.obj.description'), intl.locale);
                                description && description.length && discountDescriptions.add(description);
                            });
                    });
            });
            return Array.from(discountDescriptions);
        };
        return _this;
    }
    Cart.prototype.componentDidMount = function () {
        var _a = this.props, cart = _a.cart, showShippingMethod = _a.showShippingMethod, readOnly = _a.readOnly;
        // Check if we should rehydrate from redux. (thus not fetching a fresh cart)
        // We want to do this when:
        // 1: there is a cart available in Redux
        // 2: the cart from redux is not unInitialized
        // 3: We are on the checkout page without a cart in localStorage
        var shouldRehydrate = cart && !statusUninit(cart) && readOnly && !hasLocalCart();
        if (!shouldRehydrate) {
            this.props.refreshCart();
        }
        if (cart &&
            statusSuccess(cart) &&
            cart.result &&
            cart.result.cartState !== 'Ordered' &&
            showShippingMethod &&
            cart.result.shippingInfo &&
            !cart.result.shippingInfo.shippingMethod) {
            this.props.updateShippingMethod({});
        }
    };
    Cart.prototype.renderEmptyCart = function () {
        var _a = this.props, intl = _a.intl, onEmptyCartButtonClick = _a.onEmptyCartButtonClick;
        return (React.createElement("div", { className: "cart" },
            React.createElement(Heading, { className: "cart__header" }, intl.getLabel('cart.title')),
            React.createElement("div", { className: "cart__empty-message" },
                React.createElement(Heading, { variant: "small" }, intl.getLabel('cart.emptyCart.title')),
                React.createElement("p", null, intl.getLabel('cart.emptyCart.message')),
                React.createElement(Button, { className: "cart__button cart__empty-message-button", color: "primary", caption: intl.getLabel('cart.actions.goBack'), onClick: onEmptyCartButtonClick || this.onGoBack }))));
    };
    Cart.prototype.getAdditionalCartCosts = function (lineItems) {
        var intl = this.props.intl;
        return lineItems
            .filter(function (lineItem) {
            return lineItem.productType.obj &&
                CommerceToolsApi.isAdditionalCartCosts(lineItem.productType.obj.name);
        })
            .map(function (lineItem) { return ({
            name: getLocalizedValue(lineItem.name, intl.locale),
            price: lineItem.variant.prices[0].value,
            sku: lineItem.variant.sku,
        }); });
    };
    Cart.prototype.getProductImageUrl = function (item) {
        var _a = this.props, isBynderImagesEnabled = _a.isBynderImagesEnabled, staticsUrl = _a.staticsUrl;
        return getItemImageUrl(staticsUrl, item, isBynderImagesEnabled);
    };
    Cart.prototype.renderLineItems = function () {
        var _this = this;
        var _a = this.props, cart = _a.cart, productRoutes = _a.productRoutes, readOnly = _a.readOnly, minimumQuantity = _a.minimumQuantity, maximumQuantity = _a.maximumQuantity, showCartDiscountOnLineItem = _a.showCartDiscountOnLineItem, multiDiscountType = _a.multiDiscountType, formatProductUrl = _a.formatProductUrl, hideStockAndDeliveryOnLineItem = _a.hideStockAndDeliveryOnLineItem, allowBackOrder = _a.allowBackOrder, stockResolverFactory = _a.stockResolverFactory, deliveryResolverFactory = _a.deliveryResolverFactory;
        if (statusUninit(cart) || statusLoading(cart) || statusFailed(cart) || !cart || !cart.result) {
            console.error('Something went wrong loading the cart!');
            return null;
        }
        // Bundle line items require the old Bloomreach ProductRoute model
        // because it doesn't use "formatProductUrl" to create PDP links
        var productRoutesLegacy = Object.entries(productRoutes !== null && productRoutes !== void 0 ? productRoutes : {}).map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return ({
                productType: key,
                route: value,
            });
        });
        var _b = cart.result, lineItems = _b.lineItems, prescriptionGlassesLineItems = _b.prescriptionGlassesLineItems;
        var availability = lineItems.map(function (lineItem) {
            if (lineItem.variant.availability) {
                return lineItem.variant.availability;
            }
            return undefined;
        }, []);
        return (React.createElement("div", { className: "cart__content" },
            React.createElement(DeliveryIndicator, { availability: availability, deliveryResolver: deliveryResolverFactory && deliveryResolverFactory(lineItems) }),
            prescriptionGlassesLineItems &&
                prescriptionGlassesLineItems.map(function (pgItem) { return (React.createElement(PrescriptionGlassesCartLineItem, { key: pgItem.id, readOnly: readOnly, prescriptionGlassesLineItem: pgItem, imageUrl: _this.getProductImageUrl(pgItem.bundleMainLineItem), onRemoveCartLineItem: _this.onRemoveCustomCartLineItem, formatProductUrl: formatProductUrl, onIncrement: _this.onIncrement, onDecrement: _this.onDecrement, maximumQuantity: maximumQuantity })); }),
            lineItems.map(function (item) {
                if (item.productType.obj &&
                    CommerceToolsApi.isAdditionalCartCosts(item.productType.obj.name)) {
                    return null;
                }
                return (React.createElement(CartLineItem$1, { key: item.id, item: item, imageUrl: _this.getProductImageUrl(item), productRoutes: productRoutesLegacy, readOnly: readOnly, minimumQuantity: minimumQuantity, maximumQuantity: maximumQuantity, onRemoveCartLineItem: _this.onRemoveCartLineItem, onDecrement: _this.onDecrement, onIncrement: _this.onIncrement, showCartDiscountOnLineItem: showCartDiscountOnLineItem, multiDiscountType: multiDiscountType, formatProductUrl: formatProductUrl, hideStockAndDeliveryOnLineItem: hideStockAndDeliveryOnLineItem, allowBackOrder: allowBackOrder, stockResolver: stockResolverFactory && stockResolverFactory(item), deliveryResolver: deliveryResolverFactory && deliveryResolverFactory([item]) }));
            })));
    };
    Cart.prototype.renderDiscountDescriptions = function () {
        var _a = this.props, cart = _a.cart, intl = _a.intl;
        if (statusUninit(cart) || statusLoading(cart) || statusFailed(cart) || !cart || !cart.result) {
            console.error('Something went wrong loading the cart!');
            return null;
        }
        var descriptions = this.getCartDiscountDescriptions();
        return (descriptions &&
            descriptions.length > 0 && (React.createElement("div", { className: "cart-pricing-details__discount-description" },
            React.createElement(Alert, { type: "info", title: intl.getLabel('cart.cart.promotion.title'), message: descriptions, className: "cart-pricing-details__alert" }))));
    };
    Cart.prototype.renderCartFooter = function () {
        var _this = this;
        var _a = this.props, readOnly = _a.readOnly, onPrimaryClick = _a.onPrimaryClick, onSecondaryClick = _a.onSecondaryClick, cart = _a.cart, deliveryTooltipMsg = _a.deliveryTooltipMsg, showSubTotal = _a.showSubTotal, showTotalDiscount = _a.showTotalDiscount, showCartDiscountDescriptions = _a.showCartDiscountDescriptions, isDiscountCodeEnabled = _a.isDiscountCodeEnabled, intl = _a.intl, appliedDiscountCodes = _a.appliedDiscountCodes;
        if (statusUninit(cart) || statusLoading(cart) || statusFailed(cart) || !cart || !cart.result) {
            console.error('Something went wrong loading the cart!');
            return null;
        }
        var _b = cart.result, totalPrice = _b.totalPrice, shippingInfo = _b.shippingInfo;
        var shippingCost = get(shippingInfo, 'taxedPrice.totalGross.centAmount', 0);
        var originalTotal = this.getOriginalTotal();
        var discountedTotal = originalTotal - totalPrice.centAmount + shippingCost;
        var additionalCartCosts = this.getAdditionalCartCosts(cart.result.lineItems);
        return (React.createElement("div", { className: "cart__footer" },
            React.createElement("div", { className: "cart-pricing-details" },
                showCartDiscountDescriptions && this.renderDiscountDescriptions(),
                React.createElement("div", { className: "cart-pricing-details__box" },
                    isDiscountCodeEnabled && !readOnly && (React.createElement("div", { className: "cart-pricing-details__row" },
                        React.createElement(DiscountCodeForm, { content: {
                                inputField: {
                                    inputId: 'discount-code',
                                    type: 'text',
                                },
                            }, onSubmit: this.onApplyDiscountCode, buttonCaptionLabel: intl.getLabel('cart.discountForm.cta'), placeholderLabel: intl.getLabel('cart.discountForm.placeholder') }))),
                    showSubTotal && (React.createElement("div", { className: "cart-pricing-details__row" },
                        React.createElement("span", { className: "cart-pricing-details__label cart-pricing-details__row--sub-total" }, intl.getLabel('cart.value.subTotal')),
                        React.createElement("span", { className: "cart-pricing-details__value" },
                            React.createElement(Price, { value: originalTotal, currency: intl.currency })))),
                    showTotalDiscount && discountedTotal > 0 && (React.createElement("div", { className: "cart-pricing-details__row" },
                        React.createElement("span", { className: "cart-pricing-details__label cart-pricing-details__row--total-discount" }, intl.getLabel('cart.value.totalDiscount')),
                        React.createElement("span", { className: "cart-pricing-details__value cart-pricing-details__value--discount" },
                            React.createElement(Price, { value: -Math.abs(discountedTotal), currency: intl.currency, type: "discount" })))),
                    appliedDiscountCodes.length > 0 &&
                        appliedDiscountCodes.map(function (discountCode) { return (React.createElement("div", { className: "cart-pricing-details__row", key: discountCode.id },
                            React.createElement("span", { className: "cart-pricing-details__label" },
                                React.createElement("div", { className: "cart__applied-discount" },
                                    React.createElement("span", { className: "cart__applied-discount-code" }, discountCode.name),
                                    React.createElement(IconButton, { className: "cart__applied-discount-button", onClick: function () { return _this.onRemoveDiscountCode(discountCode); } },
                                        React.createElement(Icon, { className: "cart__applied-discount-icon", name: "close", width: 12, height: 12 })))),
                            React.createElement("span", { className: "cart-pricing-details__value" }))); }),
                    additionalCartCosts.length > 0 &&
                        additionalCartCosts.map(function (_a, index) {
                            var name = _a.name, price = _a.price, sku = _a.sku;
                            return (React.createElement("div", { className: "cart-pricing-details__row", key: sku + "-" + index },
                                React.createElement("span", { className: "cart-pricing-details__label" }, name),
                                React.createElement("span", { className: "cart-pricing-details__value" },
                                    React.createElement(Price, { value: price.centAmount, currency: intl.currency }))));
                        }),
                    React.createElement("div", { className: "cart-pricing-details__row cart-pricing-details__row--delivery-costs" },
                        React.createElement("span", { className: "cart-pricing-details__label" }, intl.getLabel('cart.delivery')),
                        deliveryTooltipMsg && React.createElement(Tooltip, { id: "delivery-cost", message: deliveryTooltipMsg }),
                        React.createElement("span", { className: "cart-pricing-details__value cart-pricing-details__value--alternate" }, shippingCost > 0 ? (React.createElement(Price, { value: shippingCost, currency: intl.currency })) : (intl.getLabel('cart.delivery.forFree')))),
                    React.createElement("div", { className: "cart-pricing-details__row cart-pricing-details__row--totalprice" },
                        React.createElement("span", { className: "cart-pricing-details__label cart-pricing-details__label--totalprice" }, intl.getLabel('cart.value.total')),
                        React.createElement("span", { className: "cart-pricing-details__value cart-pricing-details__value--totalprice" },
                            React.createElement(Price, { value: totalPrice.centAmount, currency: intl.currency, className: "cart-pricing-details__total-price" }))))),
            !readOnly && (React.createElement("div", { className: "cart__nav" },
                React.createElement(Button, { className: "cart__button cart__nav-button", "data-t": "cart-go-back", caption: intl.getLabel('cart.actions.goBack'), variant: "outline", onClick: onSecondaryClick }),
                React.createElement(Button, { className: "cart__button cart__nav-button", "data-t": "cart-go-to-checkout", caption: intl.getLabel('cart.actions.goToCheckout'), onClick: onPrimaryClick })))));
    };
    Cart.prototype.render = function () {
        var _a = this.props, cart = _a.cart, intl = _a.intl, readOnly = _a.readOnly;
        if (!cart || statusUninit(cart) || statusLoading(cart)) {
            return (React.createElement("div", { className: "cart" },
                React.createElement(Loader, null)));
        }
        if (statusFailed(cart) ||
            !cart.result ||
            isEmptyCart(cart.result) ||
            hasOnlyAdditionalCosts(cart.result)) {
            return this.renderEmptyCart();
        }
        return (React.createElement("div", { className: "cart " + (readOnly ? 'cart--read-only' : '') },
            React.createElement(Heading, { className: "cart__header" }, intl.getLabel('cart.title')),
            this.renderLineItems(),
            this.renderCartFooter()));
    };
    Cart.defaultProps = {
        isDiscountCodeEnabled: false,
        showSubTotal: false,
        showShippingMethod: false,
        showTotalDiscount: false,
        showCartDiscountDescriptions: false,
        showCartDiscountOnLineItem: false,
        multiDiscountType: false,
        hideStockAndDeliveryOnLineItem: false,
        allowBackOrder: true,
    };
    return Cart;
}(React.Component));
var mapStateToProps$1 = function (state) { return ({
    cart: getCart$1(state),
    appliedDiscountCodes: getAppliedDiscountCodes(state),
}); };
var mapDispatchToProps = {
    refreshCart: refreshCart$1,
    removeLineItems: removeLineItems,
    removeCustomLineItems: removeCustomLineItems,
    changeQuantity: changeQuantity,
    updateShippingMethod: updateShippingMethod,
    addDiscountCode: addDiscountCode$1,
    removeDiscountCode: removeDiscountCode$1,
};
var Cart$1 = connect(mapStateToProps$1, mapDispatchToProps)(withFeatureToggles(withIntl(Cart)));

var transition = {
    duration: 0.4,
    ease: [0.33, 1, 0.68, 1],
};
var posedContent = {
    close: {
        height: 0,
        transition: transition,
    },
    open: {
        height: 'auto',
        transition: transition,
    },
};
var posedIcon = {
    close: {
        rotate: 0,
        transition: transition,
    },
    open: {
        rotate: 180,
        transition: transition,
    },
};
var posedPrice = {
    close: {
        opacity: 1,
        transition: transition,
    },
    open: {
        opacity: 0,
        transition: transition,
    },
};
var CartSlider = function (_a) {
    var cart = _a.cart, children = _a.children;
    var intl = useIntl();
    var _b = __read(React.useState(false), 2), isOpen = _b[0], setIsopen = _b[1];
    var scrollHeight = React.useRef(0);
    var itemCount = (cart === null || cart === void 0 ? void 0 : cart.lineItems) || (cart === null || cart === void 0 ? void 0 : cart.prescriptionGlassesLineItems)
        ? calcCartItemsCount(cart.lineItems, cart.prescriptionGlassesLineItems)
        : 0;
    var cartPrice = cart ? cart.totalPrice.centAmount : 0;
    var cartLabel = intl.getLabel('cart.title');
    return (React.createElement(motion.div, { className: classnames('cart-slider', { 'cart-slider--open': isOpen }), animate: isOpen ? 'open' : 'close', initial: "close" },
        React.createElement(motion.div, { className: "cart-slider__content", variants: posedContent, transition: { duration: itemCount } }, children),
        React.createElement("button", { className: "cart-slider__button", onClick: handleButtonClick, name: cartLabel },
            React.createElement("span", { className: "cart-slider__counter" },
                React.createElement(CartCounter, { count: itemCount })),
            React.createElement("span", { className: "cart-slider__cart-label" }, cartLabel),
            React.createElement(motion.span, { variants: posedPrice, className: "cart-slider__button-price", transition: { duration: itemCount } },
                React.createElement(Price, { value: cartPrice, currency: intl.currency })),
            React.createElement(motion.span, { variants: posedIcon, className: "cart-slider__icon", transition: { duration: itemCount } },
                React.createElement(Icon, { name: "chevron-down", className: classnames('cart-slider__chevron', {
                        'cart-slider__chevron--rotated': isOpen,
                    }) })))));
    function handleButtonClick() {
        if (!isOpen) {
            scrollHeight.current = window.pageYOffset;
        }
        else {
            scrollToTop(scrollHeight.current);
        }
        setIsopen(!isOpen);
    }
};
function scrollToTop(distance) {
    var scrollTo = distance > window.pageYOffset ? window.pageYOffset : distance;
    window.scrollTo(0, Math.floor(scrollTo));
}
var mapStateToProps = function (state) { return ({
    cart: getCartResult(state),
}); };
var CartSlider$1 = connect(mapStateToProps)(CartSlider);

var MiniCart = function (_a) {
    var _b = _a.alerts, alerts = _b === void 0 ? [] : _b, buttonsRef = _a.buttonsRef, children = _a.children, className = _a.className, isSmallScreen = _a.isSmallScreen, labels = _a.labels, modal = _a.modal, onClose = _a.onClose, onToCart = _a.onToCart, onToCheckout = _a.onToCheckout, open = _a.open, product = _a.product, showStickyButtons = _a.showStickyButtons;
    var Buttons = (React.createElement(React.Fragment, null,
        onToCart && (React.createElement(Button, { className: "mini-cart__button", caption: labels.toCart, href: onToCart, size: isSmallScreen ? 'small' : 'medium', "data-t": "mini-cart-go-to-cart" })),
        onToCheckout && (React.createElement(Button, { className: "mini-cart__button", caption: labels.toCheckout, variant: "outline", href: onToCheckout, size: isSmallScreen ? 'small' : 'medium', "data-t": "mini-cart-go-to-checkout" }))));
    return (React.createElement(Modal, __assign({}, modal, { className: classnames('mini-cart', className), title: labels.title, isOpen: open, showIcon: true, onModalClose: onClose }),
        React.createElement("div", { className: "mini-cart__product" },
            React.createElement("p", { className: "mini-cart__product-title" }, labels.productTitle),
            React.createElement(LineItem, null,
                React.createElement(LineItemMedia, { type: "image", className: "mini-cart__product-image", imageUrl: product.imageUrl, imageAlt: product.title }),
                React.createElement(LineItemContent, { title: product.title, body: product.body }),
                React.createElement(LineItemAside, { currency: product.price.currency, price: product.price.originalPrice, discountPrice: product.price.discountedPrice }))),
        (onToCart || onToCheckout) && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mini-cart__buttons", ref: buttonsRef }, Buttons),
            showStickyButtons ? React.createElement(StickyCallToAction, { button: Buttons }) : null)),
        alerts && React.createElement("div", { className: "mini-cart__alerts" }, alerts),
        children && React.createElement("div", { className: "mini-cart__children" }, children)));
};

var MiniCartContainer = function (props) {
    var getLabel = useIntl().getLabel;
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var labels = React.useMemo(function () { return ({
        title: getLabel('cart.minicart.title'),
        productTitle: getLabel('cart.minicart.productTitle'),
        toCart: getLabel('cart.actions.goToCart'),
        toCheckout: getLabel('cart.actions.goToCheckout'),
    }); }, []);
    var _a = __read(useInView(), 2), buttonsRef = _a[0], buttonsInview = _a[1];
    var showStickyButtons = isSmallScreen && !buttonsInview;
    return (React.createElement(MiniCart, __assign({ labels: labels, isSmallScreen: isSmallScreen, buttonsRef: buttonsRef, showStickyButtons: showStickyButtons }, props)));
};

var initialState = uninitState();
var CartReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CART_LOAD:
            return loadingState();
        case CART_FAILED:
            return failedState(action.payload.error);
        case REFRESH_CART_SUCCESS:
        case CART_SUCCESS:
            return successState(action.payload.result);
        case CART_WARNING:
            return warningState(state, action.payload.error);
        case UPDATE_LOCAL_CART:
            return successState(action.payload.cart);
        case ADD_DISCOUNT_CODE_SUCCESS:
            return successState(action.payload.result);
        default:
            return state;
    }
};

/**
 * Updates cart count and version in the local storage,
 * then emits a global custom event on window to update other components. (e.g. Header)
 */
var changeEvent;
var handleCartChange = function (cartService, cart) {
    if (!changeEvent) {
        changeEvent = Util.createCustomEvent('cart.change');
    }
    var itemCount = calcCartItemsCount(cart.lineItems, cart.prescriptionGlassesLineItems);
    cartService.setCartCount(itemCount);
    cartService.setCartVersion(cart.version);
    cartService.setCartId(cart.id);
    window.dispatchEvent(changeEvent);
};
function refreshCart() {
    var cartService, cartId, apiConfig, result, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _a.sent();
                return [4 /*yield*/, call(cartService.getCartId)];
            case 2:
                cartId = _a.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 3:
                apiConfig = _a.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to refresh cart.');
                }
                if (!!cartId) return [3 /*break*/, 5];
                return [4 /*yield*/, put(cartFailed({
                        error: { message: 'Need a valid cartId to proceed' },
                    }))];
            case 4:
                _a.sent();
                return [2 /*return*/];
            case 5:
                _a.trys.push([5, 11, , 13]);
                return [4 /*yield*/, call(Carts.getCart, apiConfig.cartsUrl, {
                        cartId: cartId,
                    })];
            case 6:
                result = _a.sent();
                if (!(result.cartState !== 'Active')) return [3 /*break*/, 8];
                return [4 /*yield*/, put(cartFailed({
                        error: { message: 'Need an Active cartState to proceed' },
                    }))];
            case 7:
                _a.sent();
                return [2 /*return*/];
            case 8: 
            // If the cart is Active, store it in localstorage
            return [4 /*yield*/, call(handleCartChange, cartService, result)];
            case 9:
                // If the cart is Active, store it in localstorage
                _a.sent();
                return [4 /*yield*/, put(refreshCartSuccess({ result: result }))];
            case 10:
                _a.sent();
                return [3 /*break*/, 13];
            case 11:
                error_1 = _a.sent();
                return [4 /*yield*/, put(refreshCartFailed(new Error("Failed to refresh the cart: " + error_1.message)))];
            case 12:
                _a.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function createCart(action) {
    var cartService, apiConfig, _a, cartDraft, formatProductUrl, result, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _b.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 2:
                apiConfig = _b.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to create cart.');
                }
                _b.label = 3;
            case 3:
                _b.trys.push([3, 8, , 10]);
                _a = action.payload, cartDraft = _a.cartDraft, formatProductUrl = _a.formatProductUrl;
                return [4 /*yield*/, call(Carts.createCart, apiConfig.cartsUrl, {
                        cartDraft: cartDraft,
                    })];
            case 4:
                result = _b.sent();
                return [4 /*yield*/, call(addToCartSdAction, __spreadArray(__spreadArray([], __read(result.lineItems)), __read((result.prescriptionGlassesLineItems || []))), formatProductUrl)];
            case 5:
                _b.sent();
                return [4 /*yield*/, call(handleCartChange, cartService, result)];
            case 6:
                _b.sent();
                return [4 /*yield*/, put(cartSuccess({ result: result }))];
            case 7:
                _b.sent();
                return [3 /*break*/, 10];
            case 8:
                error_2 = _b.sent();
                return [4 /*yield*/, put(cartFailed({ error: error_2 }))];
            case 9:
                _b.sent();
                return [2 /*return*/, error_2];
            case 10: return [2 /*return*/];
        }
    });
}
function getCart(action) {
    var cartService, cartId, apiConfig, result, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _a.sent();
                return [4 /*yield*/, call(cartService.getCartId)];
            case 2:
                cartId = _a.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 3:
                apiConfig = _a.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to get a cart.');
                }
                if (!!cartId) return [3 /*break*/, 6];
                return [4 /*yield*/, put(cartFailed({ error: { message: 'Need cartId to fetch a cart' } }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, cancel()];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                _a.trys.push([6, 10, , 12]);
                return [4 /*yield*/, call(Carts.getCart, apiConfig.cartsUrl, {
                        cartId: cartId,
                    })];
            case 7:
                result = _a.sent();
                return [4 /*yield*/, call(handleCartChange, cartService, result)];
            case 8:
                _a.sent();
                return [4 /*yield*/, put(cartSuccess({ result: result }))];
            case 9:
                _a.sent();
                return [3 /*break*/, 12];
            case 10:
                error_3 = _a.sent();
                return [4 /*yield*/, put(cartFailed(error_3))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function setShippingMethod(action) {
    var cartService, cartId, apiConfig, cart, methods, selectedShippingMethod, defaultShippingMethod, shippingMethod, updateCartPayload, updatedCart, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _a.sent();
                return [4 /*yield*/, call(cartService.getCartId)];
            case 2:
                cartId = _a.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 3:
                apiConfig = _a.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to set shipping methods.');
                }
                if (!!cartId) return [3 /*break*/, 5];
                return [4 /*yield*/, put(cartFailed({ error: { message: 'Need cartId to fetch a cart' } }))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [4 /*yield*/, select(getCartResult)];
            case 6:
                cart = _a.sent();
                if (!cart) {
                    throw new Error("Need to have a cart to update!");
                }
                _a.label = 7;
            case 7:
                _a.trys.push([7, 12, , 14]);
                return [4 /*yield*/, call(Carts.getShippingMethods, apiConfig.cartsUrl, { cartId: cartId })];
            case 8:
                methods = _a.sent();
                selectedShippingMethod = methods.find(function (method) { return method.name === action.payload.shippingMethodKey; });
                defaultShippingMethod = getDefaultShippingMethod(methods);
                shippingMethod = {
                    action: 'setShippingMethod',
                    shippingMethod: {
                        typeId: 'shipping-method',
                        id: selectedShippingMethod ? selectedShippingMethod.id : defaultShippingMethod.id,
                    },
                };
                updateCartPayload = {
                    cartId: cartId,
                    cartVersion: cart.version,
                    actions: [shippingMethod],
                };
                return [4 /*yield*/, call(Carts.updateCart, apiConfig.cartsUrl, updateCartPayload)];
            case 9:
                updatedCart = _a.sent();
                return [4 /*yield*/, call(handleCartChange, cartService, updatedCart)];
            case 10:
                _a.sent();
                return [4 /*yield*/, put(updateLocalCart({ cart: updatedCart }))];
            case 11:
                _a.sent();
                return [3 /*break*/, 14];
            case 12:
                error_4 = _a.sent();
                return [4 /*yield*/, put(cartFailed({ error: error_4 }))];
            case 13:
                _a.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function addToCart(action) {
    var formatProductUrl, cartService, cartId, isUpdate, cartDraft, error, lineItems, prescriptionGlassesLineItems, error, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formatProductUrl = action.payload.formatProductUrl;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 15, , 17]);
                return [4 /*yield*/, call(CartService)];
            case 2:
                cartService = _a.sent();
                return [4 /*yield*/, call(cartService.getCartId)];
            case 3:
                cartId = _a.sent();
                isUpdate = !!cartId;
                return [4 /*yield*/, call(parseAddToCartPayload, action.payload, isUpdate)];
            case 4:
                cartDraft = _a.sent();
                if (!(!cartDraft.lineItems && !cartDraft.prescriptionGlassesLineItems)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(addToCartFailed(new Error('Need at least lineItems or prescriptionGlassesLineItems'), action.sequenceId))];
            case 5:
                _a.sent();
                return [2 /*return*/];
            case 6:
                if (!!cartId) return [3 /*break*/, 10];
                return [4 /*yield*/, call(createCart, createCart$1({
                        cartDraft: cartDraft,
                        formatProductUrl: formatProductUrl,
                    }))];
            case 7:
                error = _a.sent();
                if (!error) return [3 /*break*/, 9];
                return [4 /*yield*/, put(addToCartFailed(error, action.sequenceId))];
            case 8:
                _a.sent();
                return [2 /*return*/];
            case 9: return [3 /*break*/, 13];
            case 10:
                lineItems = cartDraft.lineItems, prescriptionGlassesLineItems = cartDraft.prescriptionGlassesLineItems;
                return [4 /*yield*/, call(addLineItems, addLineItems$1({
                        lineItems: lineItems,
                        prescriptionGlassesBundleLineItems: prescriptionGlassesLineItems,
                        formatProductUrl: formatProductUrl,
                    }))];
            case 11:
                error = _a.sent();
                if (!error) return [3 /*break*/, 13];
                return [4 /*yield*/, put(addToCartFailed(error, action.sequenceId))];
            case 12:
                _a.sent();
                return [2 /*return*/];
            case 13: return [4 /*yield*/, put(addToCartSuccess(action.sequenceId))];
            case 14:
                _a.sent();
                return [3 /*break*/, 17];
            case 15:
                error_5 = _a.sent();
                return [4 /*yield*/, put(addToCartFailed(error_5, action.sequenceId))];
            case 16:
                _a.sent();
                return [3 /*break*/, 17];
            case 17: return [2 /*return*/];
        }
    });
}
function updateQuantity(action) {
    var cartService, cartId, apiConfig, _a, lineItem, newQuantity, formatProductUrl, prescriptionGlassesLineItem, item, cart, result, error_6;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _b.sent();
                return [4 /*yield*/, call(cartService.getCartId)];
            case 2:
                cartId = _b.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 3:
                apiConfig = _b.sent();
                _a = action.payload, lineItem = _a.lineItem, newQuantity = _a.newQuantity, formatProductUrl = _a.formatProductUrl, prescriptionGlassesLineItem = _a.prescriptionGlassesLineItem;
                item = lineItem || prescriptionGlassesLineItem;
                if (!item) {
                    throw new Error('Need item to update quantity');
                }
                return [4 /*yield*/, select(getCartResult)];
            case 4:
                cart = _b.sent();
                if (!cart) {
                    throw new Error("Need to have a cart to update!");
                }
                if (!apiConfig || !newQuantity || !cartId) {
                    throw new Error('Need API configuration, newQuantity and cartId to function to update quantity!');
                }
                _b.label = 5;
            case 5:
                _b.trys.push([5, 11, , 13]);
                return [4 /*yield*/, call(lineItem ? Carts.setLineItemQuantity : Carts.setCustomLineItemQuantity, apiConfig.cartsUrl, {
                        cartId: cartId,
                        cartVersion: cart.version,
                        lineItemId: item.id,
                        lineItemQuantity: newQuantity,
                    })];
            case 6:
                result = _b.sent();
                return [4 /*yield*/, call(compareDiscountCodes, result.discountCodes)];
            case 7:
                _b.sent();
                return [4 /*yield*/, call(updateQuantitySdAction, item, newQuantity, formatProductUrl)];
            case 8:
                _b.sent();
                return [4 /*yield*/, call(handleCartChange, cartService, result)];
            case 9:
                _b.sent();
                return [4 /*yield*/, put(updateLocalCart({ cart: result }))];
            case 10:
                _b.sent();
                return [3 /*break*/, 13];
            case 11:
                error_6 = _b.sent();
                return [4 /*yield*/, put(cartFailed({ error: error_6 }))];
            case 12:
                _b.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function addDiscountCode(action) {
    var cartService, cartId, apiConfig, discountCode, cart, addDiscountCode_1, updateCartPayload, updatedCart, discountCodeState, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _a.sent();
                return [4 /*yield*/, call(cartService.getCartId)];
            case 2:
                cartId = _a.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 3:
                apiConfig = _a.sent();
                discountCode = action.payload.discountCode;
                return [4 /*yield*/, select(getCartResult)];
            case 4:
                cart = _a.sent();
                if (!cart) {
                    throw new Error("Need to have a cart to update!");
                }
                if (!cartId || !apiConfig || !discountCode) {
                    throw new Error('Need cartId, API configuration, discountCode to function to add discount code to the cart!');
                }
                _a.label = 5;
            case 5:
                _a.trys.push([5, 11, , 14]);
                addDiscountCode_1 = {
                    action: 'addDiscountCode',
                    code: discountCode,
                };
                updateCartPayload = {
                    cartId: cartId,
                    cartVersion: cart.version,
                    actions: [addDiscountCode_1],
                };
                return [4 /*yield*/, call(Carts.updateCart, apiConfig.cartsUrl, updateCartPayload)];
            case 6:
                updatedCart = _a.sent();
                return [4 /*yield*/, call(findAppliedDiscount, discountCode, updatedCart.discountCodes)];
            case 7:
                discountCodeState = (_a.sent()).state;
                return [4 /*yield*/, call(showDiscountToast, discountCodeState)];
            case 8:
                _a.sent();
                return [4 /*yield*/, put(addDiscountCodeSuccess({ result: updatedCart }))];
            case 9:
                _a.sent();
                return [4 /*yield*/, call(handleCartChange, cartService, updatedCart)];
            case 10:
                _a.sent();
                return [3 /*break*/, 14];
            case 11:
                error_7 = _a.sent();
                return [4 /*yield*/, call(showDiscountToast)];
            case 12:
                _a.sent();
                return [4 /*yield*/, put(cartWarning({ error: error_7 }))];
            case 13:
                _a.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function removeDiscountCode(action) {
    var cartService, cartId, apiConfig, discountCodeId, cart, removeDiscountCode_1, updateCartPayload, updatedCart, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _a.sent();
                return [4 /*yield*/, call(cartService.getCartId)];
            case 2:
                cartId = _a.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 3:
                apiConfig = _a.sent();
                discountCodeId = action.payload.discountCodeId;
                return [4 /*yield*/, select(getCartResult)];
            case 4:
                cart = _a.sent();
                if (!cart) {
                    throw new Error("Need to have a cart to update!");
                }
                if (!cartId || !apiConfig || !discountCodeId) {
                    throw new Error('Need cartId, API configuration, discountCodeId to function to remove discount code from the cart!');
                }
                _a.label = 5;
            case 5:
                _a.trys.push([5, 9, , 10]);
                removeDiscountCode_1 = {
                    action: 'removeDiscountCode',
                    discountCode: {
                        typeId: 'discount-code',
                        id: discountCodeId,
                    },
                };
                updateCartPayload = {
                    cartId: cartId,
                    cartVersion: cart.version,
                    actions: [removeDiscountCode_1],
                };
                return [4 /*yield*/, call(Carts.updateCart, apiConfig.cartsUrl, updateCartPayload)];
            case 6:
                updatedCart = _a.sent();
                return [4 /*yield*/, call(handleCartChange, cartService, updatedCart)];
            case 7:
                _a.sent();
                return [4 /*yield*/, put(updateLocalCart({ cart: updatedCart }))];
            case 8:
                _a.sent();
                return [3 /*break*/, 10];
            case 9:
                error_8 = _a.sent();
                console.error('Unable to remove this discount code', error_8);
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function addLineItems(action) {
    var _a, lineItems, prescriptionGlassesBundleLineItems, formatProductUrl, cartService, cartId, cart, apiConfig, doesNotContainLineItems, skus_1, actions_1, updateCartPayload, updatedCart, newLineItems, oldPgLineItemIds_1, pgItems, error_9;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = action.payload, lineItems = _a.lineItems, prescriptionGlassesBundleLineItems = _a.prescriptionGlassesBundleLineItems, formatProductUrl = _a.formatProductUrl;
                return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _d.sent();
                return [4 /*yield*/, call(cartService.getCartId)];
            case 2:
                cartId = _d.sent();
                return [4 /*yield*/, select(getCartResult)];
            case 3:
                cart = _d.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)
                    // If there is a cart ID in local storage but no cart in Redux, refresh to get the latest cart
                ];
            case 4:
                apiConfig = _d.sent();
                if (!(!cart && cartId)) return [3 /*break*/, 7];
                return [4 /*yield*/, call(refreshCart)];
            case 5:
                _d.sent();
                return [4 /*yield*/, select(getCartResult)];
            case 6:
                cart = _d.sent();
                _d.label = 7;
            case 7:
                doesNotContainLineItems = !lineItems && !prescriptionGlassesBundleLineItems;
                if (!apiConfig || !cartId || doesNotContainLineItems) {
                    throw new Error('Need API configuration, cartId and lineItems to add line item!');
                }
                _d.label = 8;
            case 8:
                _d.trys.push([8, 13, , 15]);
                skus_1 = [];
                actions_1 = [];
                lineItems === null || lineItems === void 0 ? void 0 : lineItems.forEach(function (lineItemDraft) {
                    skus_1.push(lineItemDraft.sku);
                    actions_1.push(__assign(__assign({}, lineItemDraft), { action: 'addLineItem' }));
                });
                if (prescriptionGlassesBundleLineItems) {
                    prescriptionGlassesBundleLineItems.forEach(function (bundle) {
                        actions_1.push({
                            action: 'addPrescriptionGlassesLineItem',
                            prescriptionGlassesLineItem: bundle,
                        });
                    });
                }
                updateCartPayload = {
                    cartId: cartId,
                    cartVersion: cart.version,
                    actions: actions_1,
                };
                return [4 /*yield*/, call(Carts.updateCart, apiConfig.cartsUrl, updateCartPayload)];
            case 9:
                updatedCart = _d.sent();
                newLineItems = updatedCart.lineItems.filter(function (lineItem) { return skus_1.includes(lineItem.variant.sku); });
                if (prescriptionGlassesBundleLineItems) {
                    oldPgLineItemIds_1 = new Set((_b = cart === null || cart === void 0 ? void 0 : cart.prescriptionGlassesLineItems) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                        var id = _a.id;
                        return id;
                    }));
                    pgItems = ((_c = updatedCart.prescriptionGlassesLineItems) === null || _c === void 0 ? void 0 : _c.filter(function (lineItem) { return !oldPgLineItemIds_1.has(lineItem.id); })) || [];
                    newLineItems.push.apply(newLineItems, __spreadArray([], __read(pgItems)));
                }
                return [4 /*yield*/, call(addToCartSdAction, newLineItems, formatProductUrl)];
            case 10:
                _d.sent();
                return [4 /*yield*/, call(handleCartChange, cartService, updatedCart)];
            case 11:
                _d.sent();
                return [4 /*yield*/, put(updateLocalCart({ cart: updatedCart }))];
            case 12:
                _d.sent();
                return [3 /*break*/, 15];
            case 13:
                error_9 = _d.sent();
                return [4 /*yield*/, put(cartFailed({ error: error_9 }))];
            case 14:
                _d.sent();
                return [2 /*return*/, error_9];
            case 15: return [2 /*return*/];
        }
    });
}
function onRemoveLineItems(action) {
    var cartService, cartId, apiConfig, _a, lineItems, formatProductUrl, cart, actions$2, updateCartPayload, updatedCart, error_10;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _b.sent();
                return [4 /*yield*/, call(cartService.getCartId)];
            case 2:
                cartId = _b.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 3:
                apiConfig = _b.sent();
                _a = action.payload, lineItems = _a.lineItems, formatProductUrl = _a.formatProductUrl;
                return [4 /*yield*/, select(getCartResult)
                    // If there is a cart ID in local storage but no cart in Redux, refresh to get the latest cart (checkout edge case)
                ];
            case 4:
                cart = _b.sent();
                if (!(!cart && cartId)) return [3 /*break*/, 7];
                return [4 /*yield*/, call(refreshCart)];
            case 5:
                _b.sent();
                return [4 /*yield*/, select(getCartResult)];
            case 6:
                cart = _b.sent();
                _b.label = 7;
            case 7:
                if (!cart) {
                    throw new Error("Need to have a cart to update!");
                }
                if (!apiConfig || !cartId || !lineItems) {
                    throw new Error('Need API configuration, lineItems and cartId to function to remove line item!');
                }
                _b.label = 8;
            case 8:
                _b.trys.push([8, 14, , 16]);
                actions$2 = void 0;
                if (actions$1.isType(action, removeCustomLineItems)) {
                    actions$2 = action.payload.lineItems.map(function (lineItem) { return ({
                        action: 'removeCustomLineItem',
                        customLineItemId: lineItem.id,
                    }); });
                }
                else {
                    actions$2 = action.payload.lineItems.map(function (lineItem) { return ({
                        action: 'removeLineItem',
                        lineItemId: lineItem.id,
                    }); });
                }
                updateCartPayload = {
                    cartId: cartId,
                    cartVersion: cart.version,
                    actions: actions$2,
                };
                return [4 /*yield*/, call(Carts.updateCart, apiConfig.cartsUrl, updateCartPayload)];
            case 9:
                updatedCart = _b.sent();
                return [4 /*yield*/, call(removeLineItemsSdAction, action.payload.lineItems, formatProductUrl)];
            case 10:
                _b.sent();
                return [4 /*yield*/, call(compareDiscountCodes, updatedCart.discountCodes)];
            case 11:
                _b.sent();
                return [4 /*yield*/, call(handleCartChange, cartService, updatedCart)];
            case 12:
                _b.sent();
                return [4 /*yield*/, put(updateLocalCart({ cart: updatedCart }))];
            case 13:
                _b.sent();
                return [3 /*break*/, 16];
            case 14:
                error_10 = _b.sent();
                return [4 /*yield*/, put(cartFailed({ error: error_10 }))];
            case 15:
                _b.sent();
                return [3 /*break*/, 16];
            case 16: return [2 /*return*/];
        }
    });
}
function updateCart(action) {
    var cartService, cartId, apiConfig, actions$1, cart, updateCartPayload, updatedCart, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _a.sent();
                return [4 /*yield*/, call(cartService.getCartId)];
            case 2:
                cartId = _a.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 3:
                apiConfig = _a.sent();
                actions$1 = action.payload.actions;
                return [4 /*yield*/, select(getCartResult)];
            case 4:
                cart = _a.sent();
                if (!cart) {
                    throw new Error("Need to have a cart to update!");
                }
                if (!apiConfig || !actions$1 || !cartId) {
                    throw new Error('Need API configuration, actions and cartId to function to update cart!');
                }
                _a.label = 5;
            case 5:
                _a.trys.push([5, 9, , 11]);
                updateCartPayload = {
                    cartId: cartId,
                    cartVersion: cart.version,
                    actions: actions$1,
                };
                return [4 /*yield*/, call(Carts.updateCart, apiConfig.cartsUrl, updateCartPayload)];
            case 6:
                updatedCart = _a.sent();
                return [4 /*yield*/, call(handleCartChange, cartService, updatedCart)];
            case 7:
                _a.sent();
                return [4 /*yield*/, put(updateLocalCart({ cart: updatedCart }))];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9:
                error_11 = _a.sent();
                return [4 /*yield*/, put(cartFailed({ error: error_11 }))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
// Replicates cart from an orderId
function replicateCartFromOrderId(orderId) {
    var cartService, apiConfig, cart;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _a.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 2:
                apiConfig = _a.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to replicate cart.');
                }
                if (!orderId) {
                    throw new Error('Need orderId in order to replicate cart from order');
                }
                return [4 /*yield*/, call(Carts.replicateCart, apiConfig.cartsUrl, {
                        reference: {
                            typeId: 'order',
                            id: orderId,
                        },
                    })];
            case 3:
                cart = _a.sent();
                return [4 /*yield*/, call(handleCartChange, cartService, cart)];
            case 4:
                _a.sent();
                return [4 /*yield*/, put(updateLocalCart({ cart: cart }))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// Replicates cart from an order or cart reference
function replicateCart(action) {
    var cartService, apiConfig, reference, cart, error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _a.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 2:
                apiConfig = _a.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to replicate cart.');
                }
                _a.label = 3;
            case 3:
                _a.trys.push([3, 7, , 9]);
                reference = action.payload.reference;
                return [4 /*yield*/, call(Carts.replicateCart, apiConfig.cartsUrl, {
                        reference: reference,
                    })];
            case 4:
                cart = _a.sent();
                return [4 /*yield*/, call(handleCartChange, cartService, cart)];
            case 5:
                _a.sent();
                return [4 /*yield*/, put(updateLocalCart({ cart: cart }))];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7:
                error_12 = _a.sent();
                return [4 /*yield*/, put(cartFailed({ error: error_12 }))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function compareDiscountCodes(discountCodes) {
    var prevCodes, changedCodes, changedCodes_1, changedCodes_1_1, code, e_1_1;
    var e_1, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getDiscountCodes)];
            case 1:
                prevCodes = _b.sent();
                return [4 /*yield*/, call(getChangedDiscountCodes, prevCodes, discountCodes)];
            case 2:
                changedCodes = _b.sent();
                _b.label = 3;
            case 3:
                _b.trys.push([3, 10, 11, 12]);
                changedCodes_1 = __values(changedCodes), changedCodes_1_1 = changedCodes_1.next();
                _b.label = 4;
            case 4:
                if (!!changedCodes_1_1.done) return [3 /*break*/, 9];
                code = changedCodes_1_1.value;
                if (!(code.state !== 'MatchesCart')) return [3 /*break*/, 6];
                return [4 /*yield*/, call(toast.warning, 'cart.validations.discountcode.mutated')];
            case 5:
                _b.sent();
                return [3 /*break*/, 8];
            case 6:
                if (!(code.state === 'MatchesCart')) return [3 /*break*/, 8];
                return [4 /*yield*/, call(toast.success, 'cart.validations.discountcode.matchescart')];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8:
                changedCodes_1_1 = changedCodes_1.next();
                return [3 /*break*/, 4];
            case 9: return [3 /*break*/, 12];
            case 10:
                e_1_1 = _b.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 12];
            case 11:
                try {
                    if (changedCodes_1_1 && !changedCodes_1_1.done && (_a = changedCodes_1.return)) _a.call(changedCodes_1);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 12: return [2 /*return*/];
        }
    });
}
function showDiscountToast(codeState) {
    var toastType, labelKey;
    if (codeState === void 0) { codeState = 'NotValid'; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                toastType = codeState === 'MatchesCart' ? 'success' : 'failed';
                labelKey = discountCodeValidationMap[codeState];
                return [4 /*yield*/, call(toast[toastType], "cart." + labelKey)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onCartFailed(action) {
    var error, cartService, _a, cartId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                error = action.payload.error;
                return [4 /*yield*/, call(CartService)];
            case 1:
                cartService = _b.sent();
                _a = error.statusCode;
                switch (_a) {
                    case 400: return [3 /*break*/, 2];
                    case 404: return [3 /*break*/, 6];
                    case 409: return [3 /*break*/, 9];
                    case 422: return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2: return [4 /*yield*/, call(cartService.getCartId)];
            case 3:
                cartId = _b.sent();
                if (!cartId) {
                    throw new Error('Unable to restore cart without a valid cart ID!');
                }
                return [4 /*yield*/, put(replicateCart$1({
                        reference: {
                            typeId: 'cart',
                            id: cartId,
                        },
                    }))];
            case 4:
                _b.sent();
                return [4 /*yield*/, call(toast.failed, 'cart.errors.cartNotInActiveState')];
            case 5:
                _b.sent();
                return [3 /*break*/, 16];
            case 6: 
            // Cart not found
            return [4 /*yield*/, call(cartService.removeCartFromStorage)];
            case 7:
                // Cart not found
                _b.sent();
                return [4 /*yield*/, call(toast.failed, 'cart.errors.cartNotFound')];
            case 8:
                _b.sent();
                return [3 /*break*/, 16];
            case 9: 
            // Cart version mismatch
            return [4 /*yield*/, put(refreshCart$1())];
            case 10:
                // Cart version mismatch
                _b.sent();
                return [4 /*yield*/, call(toast.failed, 'cart.errors.cartVersionMismatch')];
            case 11:
                _b.sent();
                return [3 /*break*/, 16];
            case 12: 
            // Cart validation failed
            return [4 /*yield*/, put(cartValidationFailed({ error: error }))];
            case 13:
                // Cart validation failed
                _b.sent();
                return [3 /*break*/, 16];
            case 14: return [4 /*yield*/, call(cartService.removeCartFromStorage)];
            case 15:
                _b.sent();
                _b.label = 16;
            case 16: return [2 /*return*/];
        }
    });
}
/**
 * In some cases the cart service will return an ErrorCode based on failed validations.
 * In these cases we want to show a toast to the user with the corresponding label for that validation error code.
 */
var validationErrorLabelMap = {
    ContainsMutuallyExclusiveProductTypes: 'validations.containsMutuallyExclusiveProductTypes',
    MaxQuantitySkuExceeded: 'validations.maxQuantitySkuExceeded',
    MaxMasterVariantQuantityExceeded: 'validations.maxMasterVariantQuantityExceeded',
    MaxVariantsPerProductTypeQuantityExceeded: 'validations.maxVariantsPerProductTypeQuantityExceeded',
    QuantityExceededPrescriptionExpiryDate: 'validations.quantityExceededPrescriptionExpiryDate',
    UnavailableProductsInCart: 'validations.unavailableProductsInCart',
    PrescriptionGlassesInvalidBundleCombination: 'validations.prescriptionGlassesInvalidBundleCombination',
    PrescriptionGlassesInvalidOpticalParameters: 'validations.prescriptionGlassesInvalidOpticalParameters',
};
function handleValidationError(action) {
    var error, isKnownError, errorCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                error = action.payload.error;
                isKnownError = function (error) {
                    return error.customData.validationErrorCode in Carts.ValidationErrorCode;
                };
                if (!isKnownError(error)) return [3 /*break*/, 2];
                errorCode = error.customData.validationErrorCode;
                return [4 /*yield*/, call(toast.failed, "cart." + validationErrorLabelMap[errorCode])];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2: throw new Error('Unknown validation code returned from server');
            case 3: return [2 /*return*/];
        }
    });
}
function sagas () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(CART_LOAD, getCart),
                    takeLeading(ADD_TO_CART, addToCart),
                    takeLeading(CREATE_CART, createCart),
                    takeLeading(UPDATE_SHIPPING_METHOD, setShippingMethod),
                    takeLeading(CHANGE_QUANTITY, updateQuantity),
                    takeLeading(ADD_LINE_ITEMS, addLineItems),
                    takeLeading(removeLineItems.type, onRemoveLineItems),
                    takeLeading(removeCustomLineItems.type, onRemoveLineItems),
                    takeLeading(ADD_DISCOUNT_CODE, addDiscountCode),
                    takeLeading(REMOVE_DISCOUNT_CODE, removeDiscountCode),
                    takeLeading(REPLICATE_CART, replicateCart),
                    takeLeading(UPDATE_CART, updateCart),
                    takeLatest(CART_FAILED, onCartFailed),
                    takeLatest(CART_VALIDATION_FAILED, handleValidationError),
                    takeLatest(REFRESH_CART, refreshCart),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

ReducersRegistry.register('cart', CartReducer);
SagaRegistry.register('cart', sagas);

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Actions: actions,
  Selectors: selectors,
  handleCartChange: handleCartChange,
  getCart: getCart,
  refreshCart: refreshCart,
  replicateCartFromOrderId: replicateCartFromOrderId
});

export { AddToCartContainer as AddToCart, AddToCartNotification, Cart$1 as Cart, CartLineItem$1 as CartLineItem, CartSlider$1 as CartSlider, MiniCartContainer as MiniCart, PrescriptionGlassesCartLineItem, index as ReduxDataSource, index$1 as Utils };
//# sourceMappingURL=index.js.map
